/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * PASSWD
 * Passwd backend
 * OpenAPI spec version: 2.28.0
 */
import {
    useMutation,
    useQuery,
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type MutationFunction,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseMutationOptions,
    type UseMutationResult,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';

import { fetcher, type BodyType, type ErrorType } from '../fetcher/fetcher';
import type {
    AdminPricingSettingsResponseResponse,
    AdminSettingsResponseResponse,
    AssertionResponse,
    AttestationResponse,
    AuthenticatePasskeyPathParameters,
    BadRequestErrorResponseResponse,
    CallbackRequestBodyBody,
    CheckoutRequestBodyBody,
    CheckoutResponseBodyResponse,
    ClientIdResponseResponse,
    CollectFeedbackRequestBodyBody,
    CollectFeedbackResponseResponse,
    ContactListParams,
    ContactQuery200,
    ContactQueryParams,
    CreateApiKeyRequestBodyBody,
    CreateApiKeyResponseResponse,
    CreateSecretRequestBodyBody,
    CreateSecretResponseResponse,
    CreateVaultRequestBodyBody,
    DeleteApiKeyPathParameters,
    DeletePersonalVaultAdministrationPathParameters,
    DeleteVaultPathParameters,
    DetailSecretResponseResponse,
    ExportSecretsResponseResponse,
    ExportVaultSecretsPathParameters,
    ExtensionTrialResponseResponse,
    FirefoxLoginResponseResponse,
    ForbiddenErrorResponseResponse,
    GetApiKeyPathParameters,
    GetApiKeyResponseResponse,
    GetSharedSecretPathParameters,
    GetSharedSecretTOTPPathParameters,
    GetTokensParams,
    GroupMembersPathParameters,
    GroupMembersResponseResponse,
    GroupsQuery200,
    GroupsQueryParams,
    HelloResponseResponse,
    HiddenGroupsResponseResponse,
    HideGroupFromSecretsPathParameters,
    HttpError,
    ImportSecretsRequestBodyBody,
    ImportVaultSecretsPathParameters,
    ImportVaultSecretsRequestBodyBody,
    ListApiKeysResponseResponse,
    ListGroupAdministrationResponseResponse,
    ListGroupsAdministrationParams,
    ListPersonalVaultsAdministrationResponseResponse,
    ListSecretParams,
    ListSecretResponseResponse,
    ListUsersAdministrationParams,
    ListVaultsParams,
    ListVaultsResponseResponse,
    NotFoundErrorResponseResponse,
    Notification,
    OAuthCallbackResponseResponse,
    OrganizationDetailPathParameters,
    OrganizationDetailResponseResponse,
    PreconditionRequiredErrorResponseResponse,
    PublicDeleteSecretPathParameters,
    PublicGetSecretPathParameters,
    PublicKeyCredentialCreationOptions,
    PublicKeyCredentialGetOptions,
    PublicListSecretsParams,
    PublicUpdateSecretPathParameters,
    RefreshSharedSecretPathParameters,
    RefreshTokenRequestBodyBody,
    RefreshTokenResponseResponse,
    ReportSecretsResponseResponse,
    ResetSandboxParams,
    SandboxContactsRequestBodyBody,
    SandboxContactsResponseResponse,
    SandboxResetResponseResponse,
    SecretDeletePathParameters,
    SecretDetailPathParameters,
    SecretUpdatePathParameters,
    SecurityAuditSummaryResponseResponse,
    SettingsRequestBodyBody,
    SettingsResponseResponse,
    SharedSecret,
    ShareSecretPathParameters,
    ShowGroupInSecretsPathParameters,
    SignoutRequestBodyBody,
    TagDeletePathParameters,
    TagUpdate200,
    TagUpdatePathParameters,
    TOTPCode,
    TOTPDetail200Item,
    TOTPDetailPathParameters,
    UnauthorizedErrorResponseResponse,
    UnshareSecretPathParameters,
    UpdateApiKeyPathParameters,
    UpdateApiKeyRequestBodyBody,
    UpdateApiKeyResponseResponse,
    UpdateGroupResponseResponse,
    UpdateGroupsAdministrationBody,
    UpdateNotificationPathParameters,
    UpdateNotificationRequestBodyBody,
    UpdateSecretRequestBodyBody,
    UpdateSecretResponseResponse,
    UpdateTagRequestBodyBody,
    UpdateUserResponseResponse,
    UpdateUsersAdministrationBody,
    UpdateVaultPathParameters,
    UpdateVaultRequestBodyBody,
    UserAdministrationResponseResponse,
    UserObject,
    UserProfileObject,
    ValidateSecretsRequestBodyBody,
    ValidateVaultSecretsPathParameters,
    VaultDetailPathParameters,
    VaultResponseResponse,
} from './endpoints.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Hello endpoint used to awaken cloudrun
 */
export const get = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<HelloResponseResponse>({ url: `/`, method: 'GET', signal }, options);
};

export const getGetQueryKey = () => {
    return [`/`] as const;
};

export const getGetQueryOptions = <TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = ({ signal }) => get(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type GetQueryResult = NonNullable<Awaited<ReturnType<typeof get>>>;
export type GetQueryError = ErrorType<unknown>;

export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>> &
            Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof get>>, TError, Awaited<ReturnType<typeof get>>>, 'initialData'>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>> &
            Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof get>>, TError, Awaited<ReturnType<typeof get>>>, 'initialData'>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hello endpoint used to awaken cloudrun
 */

export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get client id from the server
 */
export const getClientId = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ClientIdResponseResponse>({ url: `/oauth/client-id`, method: 'GET', signal }, options);
};

export const getGetClientIdQueryKey = () => {
    return [`/oauth/client-id`] as const;
};

export const getGetClientIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getClientId>>,
    TError = ErrorType<BadRequestErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientId>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetClientIdQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientId>>> = ({ signal }) => getClientId(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getClientId>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type GetClientIdQueryResult = NonNullable<Awaited<ReturnType<typeof getClientId>>>;
export type GetClientIdQueryError = ErrorType<BadRequestErrorResponseResponse>;

export function useGetClientId<TData = Awaited<ReturnType<typeof getClientId>>, TError = ErrorType<BadRequestErrorResponseResponse>>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientId>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof getClientId>>, TError, Awaited<ReturnType<typeof getClientId>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientId<TData = Awaited<ReturnType<typeof getClientId>>, TError = ErrorType<BadRequestErrorResponseResponse>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientId>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof getClientId>>, TError, Awaited<ReturnType<typeof getClientId>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientId<TData = Awaited<ReturnType<typeof getClientId>>, TError = ErrorType<BadRequestErrorResponseResponse>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientId>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get client id from the server
 */

export function useGetClientId<TData = Awaited<ReturnType<typeof getClientId>>, TError = ErrorType<BadRequestErrorResponseResponse>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientId>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetClientIdQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get tokens from code
 */
export const getTokens = (
    params: GetTokensParams,
    callbackRequestBodyBody?: BodyType<CallbackRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<OAuthCallbackResponseResponse>(
        {
            url: `/oauth/callback`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: callbackRequestBodyBody,
            params,
            signal,
        },
        options,
    );
};

export const getGetTokensMutationOptions = <TError = ErrorType<HttpError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof getTokens>>,
        TError,
        { params: GetTokensParams; data: BodyType<CallbackRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof getTokens>>,
    TError,
    { params: GetTokensParams; data: BodyType<CallbackRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['getTokens'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof getTokens>>,
        { params: GetTokensParams; data: BodyType<CallbackRequestBodyBody> }
    > = props => {
        const { params, data } = props ?? {};

        return getTokens(params, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetTokensMutationResult = NonNullable<Awaited<ReturnType<typeof getTokens>>>;
export type GetTokensMutationBody = BodyType<CallbackRequestBodyBody>;
export type GetTokensMutationError = ErrorType<HttpError>;

/**
 * @summary Get tokens from code
 */
export const useGetTokens = <TError = ErrorType<HttpError>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof getTokens>>,
            TError,
            { params: GetTokensParams; data: BodyType<CallbackRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof getTokens>>,
    TError,
    { params: GetTokensParams; data: BodyType<CallbackRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getGetTokensMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Refresh access token from refresh token
 */
export const refreshAccessToken = (
    refreshTokenRequestBodyBody: BodyType<RefreshTokenRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<RefreshTokenResponseResponse>(
        {
            url: `/oauth/refresh-token`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: refreshTokenRequestBodyBody,
            signal,
        },
        options,
    );
};

export const getRefreshAccessTokenMutationOptions = <TError = ErrorType<HttpError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof refreshAccessToken>>,
        TError,
        { data: BodyType<RefreshTokenRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof refreshAccessToken>>,
    TError,
    { data: BodyType<RefreshTokenRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['refreshAccessToken'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof refreshAccessToken>>,
        { data: BodyType<RefreshTokenRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return refreshAccessToken(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type RefreshAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccessToken>>>;
export type RefreshAccessTokenMutationBody = BodyType<RefreshTokenRequestBodyBody>;
export type RefreshAccessTokenMutationError = ErrorType<HttpError>;

/**
 * @summary Refresh access token from refresh token
 */
export const useRefreshAccessToken = <TError = ErrorType<HttpError>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof refreshAccessToken>>,
            TError,
            { data: BodyType<RefreshTokenRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof refreshAccessToken>>, TError, { data: BodyType<RefreshTokenRequestBodyBody> }, TContext> => {
    const mutationOptions = getRefreshAccessTokenMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Revoke the refresh and access tokens - Used for all device logout (Invalidates all tokens for the user)
 */
export const signOut = (
    signoutRequestBodyBody: BodyType<SignoutRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<void>(
        { url: `/oauth/signout`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: signoutRequestBodyBody, signal },
        options,
    );
};

export const getSignOutMutationOptions = <TError = ErrorType<HttpError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, { data: BodyType<SignoutRequestBodyBody> }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, { data: BodyType<SignoutRequestBodyBody> }, TContext> => {
    const mutationKey = ['signOut'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOut>>, { data: BodyType<SignoutRequestBodyBody> }> = props => {
        const { data } = props ?? {};

        return signOut(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type SignOutMutationResult = NonNullable<Awaited<ReturnType<typeof signOut>>>;
export type SignOutMutationBody = BodyType<SignoutRequestBodyBody>;
export type SignOutMutationError = ErrorType<HttpError>;

/**
 * @summary Revoke the refresh and access tokens - Used for all device logout (Invalidates all tokens for the user)
 */
export const useSignOut = <TError = ErrorType<HttpError>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, { data: BodyType<SignoutRequestBodyBody> }, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof signOut>>, TError, { data: BodyType<SignoutRequestBodyBody> }, TContext> => {
    const mutationOptions = getSignOutMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get user info
 */
export const me = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<UserProfileObject>({ url: `/me`, method: 'GET', signal }, options);
};

export const getMeQueryKey = () => {
    return [`/me`] as const;
};

export const getMeQueryOptions = <
    TData = Awaited<ReturnType<typeof me>>,
    TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getMeQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>;
export type MeQueryError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>;

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> &
            Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof me>>, TError, Awaited<ReturnType<typeof me>>>, 'initialData'>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> &
            Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof me>>, TError, Awaited<ReturnType<typeof me>>>, 'initialData'>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user info
 */

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getMeQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Update a notification for the current user
 */
export const updateNotification = (
    { notificationId }: UpdateNotificationPathParameters,
    updateNotificationRequestBodyBody: BodyType<UpdateNotificationRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<Notification>(
        {
            url: `/me/notifications/${notificationId}`,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            data: updateNotificationRequestBodyBody,
        },
        options,
    );
};

export const getUpdateNotificationMutationOptions = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | NotFoundErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateNotification>>,
        TError,
        { pathParams: UpdateNotificationPathParameters; data: BodyType<UpdateNotificationRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateNotification>>,
    TError,
    { pathParams: UpdateNotificationPathParameters; data: BodyType<UpdateNotificationRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['updateNotification'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateNotification>>,
        { pathParams: UpdateNotificationPathParameters; data: BodyType<UpdateNotificationRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return updateNotification(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotification>>>;
export type UpdateNotificationMutationBody = BodyType<UpdateNotificationRequestBodyBody>;
export type UpdateNotificationMutationError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | NotFoundErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update a notification for the current user
 */
export const useUpdateNotification = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | NotFoundErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof updateNotification>>,
            TError,
            { pathParams: UpdateNotificationPathParameters; data: BodyType<UpdateNotificationRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof updateNotification>>,
    TError,
    { pathParams: UpdateNotificationPathParameters; data: BodyType<UpdateNotificationRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getUpdateNotificationMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create secret
 */
export const createSecret = (
    createSecretRequestBodyBody: BodyType<CreateSecretRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<CreateSecretResponseResponse>(
        { url: `/secrets`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: createSecretRequestBodyBody, signal },
        options,
    );
};

export const getCreateSecretMutationOptions = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createSecret>>,
        TError,
        { data: BodyType<CreateSecretRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof createSecret>>, TError, { data: BodyType<CreateSecretRequestBodyBody> }, TContext> => {
    const mutationKey = ['createSecret'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createSecret>>,
        { data: BodyType<CreateSecretRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return createSecret(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateSecretMutationResult = NonNullable<Awaited<ReturnType<typeof createSecret>>>;
export type CreateSecretMutationBody = BodyType<CreateSecretRequestBodyBody>;
export type CreateSecretMutationError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Create secret
 */
export const useCreateSecret = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof createSecret>>,
            TError,
            { data: BodyType<CreateSecretRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createSecret>>, TError, { data: BodyType<CreateSecretRequestBodyBody> }, TContext> => {
    const mutationOptions = getCreateSecretMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List secrets
 */
export const listSecret = (params?: ListSecretParams, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ListSecretResponseResponse>({ url: `/secrets`, method: 'GET', params, signal }, options);
};

export const getListSecretQueryKey = (params?: ListSecretParams) => {
    return [`/secrets`, ...(params ? [params] : [])] as const;
};

export const getListSecretQueryOptions = <
    TData = Awaited<ReturnType<typeof listSecret>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListSecretParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListSecretQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSecret>>> = ({ signal }) => listSecret(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof listSecret>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ListSecretQueryResult = NonNullable<Awaited<ReturnType<typeof listSecret>>>;
export type ListSecretQueryError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function useListSecret<
    TData = Awaited<ReturnType<typeof listSecret>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params: undefined | ListSecretParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecret>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof listSecret>>, TError, Awaited<ReturnType<typeof listSecret>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSecret<
    TData = Awaited<ReturnType<typeof listSecret>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListSecretParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecret>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof listSecret>>, TError, Awaited<ReturnType<typeof listSecret>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSecret<
    TData = Awaited<ReturnType<typeof listSecret>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListSecretParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List secrets
 */

export function useListSecret<
    TData = Awaited<ReturnType<typeof listSecret>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListSecretParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getListSecretQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Company-wide import, requires admin. Rows flagged `personal = true`
(secrets exported from a personal vault) are skipped. Use
`PATCH /vaults/{vaultId}/secrets` to import them into a vault.

 * @summary Import secrets from csv file
 */
export const importSecrets = (
    importSecretsRequestBodyBody: BodyType<ImportSecretsRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    const formData = new FormData();
    if (importSecretsRequestBodyBody.replaceSecrets !== undefined) {
        formData.append(`replaceSecrets`, importSecretsRequestBodyBody.replaceSecrets);
    }
    if (importSecretsRequestBodyBody.delimiter !== undefined) {
        formData.append(`delimiter`, importSecretsRequestBodyBody.delimiter);
    }
    if (importSecretsRequestBodyBody.format !== undefined) {
        formData.append(`format`, importSecretsRequestBodyBody.format);
    }
    if (importSecretsRequestBodyBody.secrets !== undefined) {
        formData.append(`secrets`, importSecretsRequestBodyBody.secrets);
    }

    return fetcher<void>({ url: `/secrets`, method: 'PATCH', headers: { 'Content-Type': 'multipart/form-data' }, data: formData }, options);
};

export const getImportSecretsMutationOptions = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof importSecrets>>,
        TError,
        { data: BodyType<ImportSecretsRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof importSecrets>>, TError, { data: BodyType<ImportSecretsRequestBodyBody> }, TContext> => {
    const mutationKey = ['importSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof importSecrets>>,
        { data: BodyType<ImportSecretsRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return importSecrets(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ImportSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof importSecrets>>>;
export type ImportSecretsMutationBody = BodyType<ImportSecretsRequestBodyBody>;
export type ImportSecretsMutationError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Import secrets from csv file
 */
export const useImportSecrets = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof importSecrets>>,
            TError,
            { data: BodyType<ImportSecretsRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof importSecrets>>, TError, { data: BodyType<ImportSecretsRequestBodyBody> }, TContext> => {
    const mutationOptions = getImportSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Detail secret
 */
export const secretDetail = ({ id }: SecretDetailPathParameters, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<DetailSecretResponseResponse>({ url: `/secrets/${id}`, method: 'GET', signal }, options);
};

export const getSecretDetailQueryKey = ({ id }: SecretDetailPathParameters) => {
    return [`/secrets/${id}`] as const;
};

export const getSecretDetailQueryOptions = <
    TData = Awaited<ReturnType<typeof secretDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    { id }: SecretDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof secretDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSecretDetailQueryKey({ id });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof secretDetail>>> = ({ signal }) => secretDetail({ id }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof secretDetail>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SecretDetailQueryResult = NonNullable<Awaited<ReturnType<typeof secretDetail>>>;
export type SecretDetailQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function useSecretDetail<
    TData = Awaited<ReturnType<typeof secretDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: SecretDetailPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof secretDetail>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof secretDetail>>, TError, Awaited<ReturnType<typeof secretDetail>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSecretDetail<
    TData = Awaited<ReturnType<typeof secretDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: SecretDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof secretDetail>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof secretDetail>>, TError, Awaited<ReturnType<typeof secretDetail>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSecretDetail<
    TData = Awaited<ReturnType<typeof secretDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: SecretDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof secretDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Detail secret
 */

export function useSecretDetail<
    TData = Awaited<ReturnType<typeof secretDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    { id }: SecretDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof secretDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getSecretDetailQueryOptions({ id }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Update secret
 */
export const secretUpdate = (
    { id }: SecretUpdatePathParameters,
    updateSecretRequestBodyBody: BodyType<UpdateSecretRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<UpdateSecretResponseResponse>(
        { url: `/secrets/${id}`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: updateSecretRequestBodyBody },
        options,
    );
};

export const getSecretUpdateMutationOptions = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof secretUpdate>>,
        TError,
        { pathParams: SecretUpdatePathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof secretUpdate>>,
    TError,
    { pathParams: SecretUpdatePathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['secretUpdate'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof secretUpdate>>,
        { pathParams: SecretUpdatePathParameters; data: BodyType<UpdateSecretRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return secretUpdate(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type SecretUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof secretUpdate>>>;
export type SecretUpdateMutationBody = BodyType<UpdateSecretRequestBodyBody>;
export type SecretUpdateMutationError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update secret
 */
export const useSecretUpdate = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof secretUpdate>>,
            TError,
            { pathParams: SecretUpdatePathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof secretUpdate>>,
    TError,
    { pathParams: SecretUpdatePathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getSecretUpdateMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete secret
 */
export const secretDelete = ({ id }: SecretDeletePathParameters, options?: SecondParameter<typeof fetcher>) => {
    return fetcher<void>({ url: `/secrets/${id}`, method: 'DELETE' }, options);
};

export const getSecretDeleteMutationOptions = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof secretDelete>>, TError, { pathParams: SecretDeletePathParameters }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof secretDelete>>, TError, { pathParams: SecretDeletePathParameters }, TContext> => {
    const mutationKey = ['secretDelete'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof secretDelete>>, { pathParams: SecretDeletePathParameters }> = props => {
        const { pathParams } = props ?? {};

        return secretDelete(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type SecretDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof secretDelete>>>;

export type SecretDeleteMutationError = ErrorType<
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Delete secret
 */
export const useSecretDelete = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof secretDelete>>,
            TError,
            { pathParams: SecretDeletePathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof secretDelete>>, TError, { pathParams: SecretDeletePathParameters }, TContext> => {
    const mutationOptions = getSecretDeleteMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Detail TOTP
 */
export const tOTPDetail = ({ id }: TOTPDetailPathParameters, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<TOTPDetail200Item[]>({ url: `/secrets/${id}/TOTP`, method: 'GET', signal }, options);
};

export const getTOTPDetailQueryKey = ({ id }: TOTPDetailPathParameters) => {
    return [`/secrets/${id}/TOTP`] as const;
};

export const getTOTPDetailQueryOptions = <
    TData = Awaited<ReturnType<typeof tOTPDetail>>,
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
    >,
>(
    { id }: TOTPDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tOTPDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTOTPDetailQueryKey({ id });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tOTPDetail>>> = ({ signal }) => tOTPDetail({ id }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof tOTPDetail>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TOTPDetailQueryResult = NonNullable<Awaited<ReturnType<typeof tOTPDetail>>>;
export type TOTPDetailQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
>;

export function useTOTPDetail<
    TData = Awaited<ReturnType<typeof tOTPDetail>>,
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: TOTPDetailPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tOTPDetail>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof tOTPDetail>>, TError, Awaited<ReturnType<typeof tOTPDetail>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTOTPDetail<
    TData = Awaited<ReturnType<typeof tOTPDetail>>,
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: TOTPDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tOTPDetail>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof tOTPDetail>>, TError, Awaited<ReturnType<typeof tOTPDetail>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTOTPDetail<
    TData = Awaited<ReturnType<typeof tOTPDetail>>,
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: TOTPDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tOTPDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Detail TOTP
 */

export function useTOTPDetail<
    TData = Awaited<ReturnType<typeof tOTPDetail>>,
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
    >,
>(
    { id }: TOTPDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tOTPDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTOTPDetailQueryOptions({ id }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Share secret publicly
 */
export const shareSecret = ({ id }: ShareSecretPathParameters, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<UpdateSecretResponseResponse>({ url: `/secrets/${id}/share`, method: 'POST', signal }, options);
};

export const getShareSecretMutationOptions = <
    TError = ErrorType<
        | HttpError
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof shareSecret>>, TError, { pathParams: ShareSecretPathParameters }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof shareSecret>>, TError, { pathParams: ShareSecretPathParameters }, TContext> => {
    const mutationKey = ['shareSecret'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareSecret>>, { pathParams: ShareSecretPathParameters }> = props => {
        const { pathParams } = props ?? {};

        return shareSecret(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ShareSecretMutationResult = NonNullable<Awaited<ReturnType<typeof shareSecret>>>;

export type ShareSecretMutationError = ErrorType<
    | HttpError
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Share secret publicly
 */
export const useShareSecret = <
    TError = ErrorType<
        | HttpError
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof shareSecret>>, TError, { pathParams: ShareSecretPathParameters }, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof shareSecret>>, TError, { pathParams: ShareSecretPathParameters }, TContext> => {
    const mutationOptions = getShareSecretMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove secret share
 */
export const unshareSecret = ({ id }: UnshareSecretPathParameters, options?: SecondParameter<typeof fetcher>) => {
    return fetcher<void>({ url: `/secrets/${id}/share`, method: 'DELETE' }, options);
};

export const getUnshareSecretMutationOptions = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof unshareSecret>>, TError, { pathParams: UnshareSecretPathParameters }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof unshareSecret>>, TError, { pathParams: UnshareSecretPathParameters }, TContext> => {
    const mutationKey = ['unshareSecret'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof unshareSecret>>, { pathParams: UnshareSecretPathParameters }> = props => {
        const { pathParams } = props ?? {};

        return unshareSecret(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type UnshareSecretMutationResult = NonNullable<Awaited<ReturnType<typeof unshareSecret>>>;

export type UnshareSecretMutationError = ErrorType<
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Remove secret share
 */
export const useUnshareSecret = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof unshareSecret>>,
            TError,
            { pathParams: UnshareSecretPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof unshareSecret>>, TError, { pathParams: UnshareSecretPathParameters }, TContext> => {
    const mutationOptions = getUnshareSecretMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

export const getSharedSecret = (
    { shareId }: GetSharedSecretPathParameters,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<SharedSecret>({ url: `/share/${shareId}`, method: 'GET', signal }, options);
};

export const getGetSharedSecretQueryKey = ({ shareId }: GetSharedSecretPathParameters) => {
    return [`/share/${shareId}`] as const;
};

export const getGetSharedSecretQueryOptions = <
    TData = Awaited<ReturnType<typeof getSharedSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError>,
>(
    { shareId }: GetSharedSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSharedSecretQueryKey({ shareId });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedSecret>>> = ({ signal }) =>
        getSharedSecret({ shareId }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!shareId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getSharedSecret>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedSecretQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedSecret>>>;
export type GetSharedSecretQueryError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError>;

export function useGetSharedSecret<
    TData = Awaited<ReturnType<typeof getSharedSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError>,
>(
    pathParams: GetSharedSecretPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecret>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof getSharedSecret>>, TError, Awaited<ReturnType<typeof getSharedSecret>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedSecret<
    TData = Awaited<ReturnType<typeof getSharedSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError>,
>(
    pathParams: GetSharedSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecret>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSharedSecret>>,
                    TError,
                    Awaited<ReturnType<typeof getSharedSecret>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedSecret<
    TData = Awaited<ReturnType<typeof getSharedSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError>,
>(
    pathParams: GetSharedSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSharedSecret<
    TData = Awaited<ReturnType<typeof getSharedSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | HttpError>,
>(
    { shareId }: GetSharedSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetSharedSecretQueryOptions({ shareId }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const refreshSharedSecret = (
    { shareId }: RefreshSharedSecretPathParameters,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<DetailSecretResponseResponse>({ url: `/share/${shareId}/refresh`, method: 'POST', signal }, options);
};

export const getRefreshSharedSecretMutationOptions = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof refreshSharedSecret>>,
        TError,
        { pathParams: RefreshSharedSecretPathParameters },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof refreshSharedSecret>>,
    TError,
    { pathParams: RefreshSharedSecretPathParameters },
    TContext
> => {
    const mutationKey = ['refreshSharedSecret'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof refreshSharedSecret>>,
        { pathParams: RefreshSharedSecretPathParameters }
    > = props => {
        const { pathParams } = props ?? {};

        return refreshSharedSecret(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type RefreshSharedSecretMutationResult = NonNullable<Awaited<ReturnType<typeof refreshSharedSecret>>>;

export type RefreshSharedSecretMutationError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse>;

export const useRefreshSharedSecret = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof refreshSharedSecret>>,
            TError,
            { pathParams: RefreshSharedSecretPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof refreshSharedSecret>>,
    TError,
    { pathParams: RefreshSharedSecretPathParameters },
    TContext
> => {
    const mutationOptions = getRefreshSharedSecretMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Detail TOTP
 */
export const getSharedSecretTOTP = (
    { shareId }: GetSharedSecretTOTPPathParameters,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<TOTPCode[]>({ url: `/share/${shareId}/totp`, method: 'GET', signal }, options);
};

export const getGetSharedSecretTOTPQueryKey = ({ shareId }: GetSharedSecretTOTPPathParameters) => {
    return [`/share/${shareId}/totp`] as const;
};

export const getGetSharedSecretTOTPQueryOptions = <TData = Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError = ErrorType<HttpError>>(
    { shareId }: GetSharedSecretTOTPPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSharedSecretTOTPQueryKey({ shareId });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedSecretTOTP>>> = ({ signal }) =>
        getSharedSecretTOTP({ shareId }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!shareId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getSharedSecretTOTP>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedSecretTOTPQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedSecretTOTP>>>;
export type GetSharedSecretTOTPQueryError = ErrorType<HttpError>;

export function useGetSharedSecretTOTP<TData = Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError = ErrorType<HttpError>>(
    pathParams: GetSharedSecretTOTPPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSharedSecretTOTP>>,
                    TError,
                    Awaited<ReturnType<typeof getSharedSecretTOTP>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedSecretTOTP<TData = Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError = ErrorType<HttpError>>(
    pathParams: GetSharedSecretTOTPPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSharedSecretTOTP>>,
                    TError,
                    Awaited<ReturnType<typeof getSharedSecretTOTP>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedSecretTOTP<TData = Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError = ErrorType<HttpError>>(
    pathParams: GetSharedSecretTOTPPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Detail TOTP
 */

export function useGetSharedSecretTOTP<TData = Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError = ErrorType<HttpError>>(
    { shareId }: GetSharedSecretTOTPPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedSecretTOTP>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetSharedSecretTOTPQueryOptions({ shareId }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Returns the caller's personal vault and all team vaults where the caller
is a member (directly or via a Google group) or the creator. Admins see
all team vaults. Vaults with `visible=false` are excluded.

Lazy provisioning: when the caller's plan includes vaults and the personal
vault does not exist yet, it is created by this call and included in the
response. On the free plan the endpoint returns an empty list (no error) —
gating errors (402) are raised only by mutating operations.

 * @summary List vaults visible to the caller
 */
export const listVaults = (params?: ListVaultsParams, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ListVaultsResponseResponse>({ url: `/vaults`, method: 'GET', params, signal }, options);
};

export const getListVaultsQueryKey = (params?: ListVaultsParams) => {
    return [`/vaults`, ...(params ? [params] : [])] as const;
};

export const getListVaultsQueryOptions = <
    TData = Awaited<ReturnType<typeof listVaults>>,
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListVaultsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listVaults>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListVaultsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVaults>>> = ({ signal }) => listVaults(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof listVaults>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ListVaultsQueryResult = NonNullable<Awaited<ReturnType<typeof listVaults>>>;
export type ListVaultsQueryError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

export function useListVaults<
    TData = Awaited<ReturnType<typeof listVaults>>,
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    params: undefined | ListVaultsParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listVaults>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof listVaults>>, TError, Awaited<ReturnType<typeof listVaults>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListVaults<
    TData = Awaited<ReturnType<typeof listVaults>>,
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListVaultsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listVaults>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof listVaults>>, TError, Awaited<ReturnType<typeof listVaults>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListVaults<
    TData = Awaited<ReturnType<typeof listVaults>>,
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListVaultsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listVaults>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List vaults visible to the caller
 */

export function useListVaults<
    TData = Awaited<ReturnType<typeof listVaults>>,
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: ListVaultsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listVaults>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getListVaultsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Only a workspace admin can create a team vault. The creator
is always persisted as an editor (even when omitted from `users`).
Personal vaults cannot be created via this endpoint (they are provisioned
automatically).

 * @summary Create a team vault
 */
export const createVault = (
    createVaultRequestBodyBody: BodyType<CreateVaultRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<VaultResponseResponse>(
        { url: `/vaults`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: createVaultRequestBodyBody, signal },
        options,
    );
};

export const getCreateVaultMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createVault>>,
        TError,
        { data: BodyType<CreateVaultRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof createVault>>, TError, { data: BodyType<CreateVaultRequestBodyBody> }, TContext> => {
    const mutationKey = ['createVault'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVault>>, { data: BodyType<CreateVaultRequestBodyBody> }> = props => {
        const { data } = props ?? {};

        return createVault(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateVaultMutationResult = NonNullable<Awaited<ReturnType<typeof createVault>>>;
export type CreateVaultMutationBody = BodyType<CreateVaultRequestBodyBody>;
export type CreateVaultMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | HttpError
    | ForbiddenErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Create a team vault
 */
export const useCreateVault = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof createVault>>,
            TError,
            { data: BodyType<CreateVaultRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createVault>>, TError, { data: BodyType<CreateVaultRequestBodyBody> }, TContext> => {
    const mutationOptions = getCreateVaultMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Visible under the same rules as the list: team vaults require membership,
creatorship or the admin role; a personal vault is visible only to its
owner. Anything else is a 404.

 * @summary Get vault detail
 */
export const vaultDetail = ({ vaultId }: VaultDetailPathParameters, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<VaultResponseResponse>({ url: `/vaults/${vaultId}`, method: 'GET', signal }, options);
};

export const getVaultDetailQueryKey = ({ vaultId }: VaultDetailPathParameters) => {
    return [`/vaults/${vaultId}`] as const;
};

export const getVaultDetailQueryOptions = <
    TData = Awaited<ReturnType<typeof vaultDetail>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    { vaultId }: VaultDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof vaultDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getVaultDetailQueryKey({ vaultId });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof vaultDetail>>> = ({ signal }) =>
        vaultDetail({ vaultId }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!vaultId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof vaultDetail>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type VaultDetailQueryResult = NonNullable<Awaited<ReturnType<typeof vaultDetail>>>;
export type VaultDetailQueryError = ErrorType<
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

export function useVaultDetail<
    TData = Awaited<ReturnType<typeof vaultDetail>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: VaultDetailPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof vaultDetail>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof vaultDetail>>, TError, Awaited<ReturnType<typeof vaultDetail>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVaultDetail<
    TData = Awaited<ReturnType<typeof vaultDetail>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: VaultDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof vaultDetail>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof vaultDetail>>, TError, Awaited<ReturnType<typeof vaultDetail>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVaultDetail<
    TData = Awaited<ReturnType<typeof vaultDetail>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: VaultDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof vaultDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get vault detail
 */

export function useVaultDetail<
    TData = Awaited<ReturnType<typeof vaultDetail>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    { vaultId }: VaultDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof vaultDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getVaultDetailQueryOptions({ vaultId }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Requires the editor role in the vault. `users` and `groups` are full
replacements (same pattern as secret sharing) — omitting a field keeps
the current value, sending an array replaces the whole member list.
The vault must always keep at least one editor (user or group);
removing the last editor is a 400. Personal vaults accept only `name`.

 * @summary Update vault name and members
 */
export const updateVault = (
    { vaultId }: UpdateVaultPathParameters,
    updateVaultRequestBodyBody: BodyType<UpdateVaultRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<VaultResponseResponse>(
        { url: `/vaults/${vaultId}`, method: 'PATCH', headers: { 'Content-Type': 'application/json' }, data: updateVaultRequestBodyBody },
        options,
    );
};

export const getUpdateVaultMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateVault>>,
        TError,
        { pathParams: UpdateVaultPathParameters; data: BodyType<UpdateVaultRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateVault>>,
    TError,
    { pathParams: UpdateVaultPathParameters; data: BodyType<UpdateVaultRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['updateVault'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateVault>>,
        { pathParams: UpdateVaultPathParameters; data: BodyType<UpdateVaultRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return updateVault(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateVaultMutationResult = NonNullable<Awaited<ReturnType<typeof updateVault>>>;
export type UpdateVaultMutationBody = BodyType<UpdateVaultRequestBodyBody>;
export type UpdateVaultMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update vault name and members
 */
export const useUpdateVault = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof updateVault>>,
            TError,
            { pathParams: UpdateVaultPathParameters; data: BodyType<UpdateVaultRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof updateVault>>,
    TError,
    { pathParams: UpdateVaultPathParameters; data: BodyType<UpdateVaultRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getUpdateVaultMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Requires the editor role in the vault. Secrets contained in the vault are
NOT deleted — their `vaultId` is cleared and their sharing permissions stay
untouched. Personal vaults cannot be deleted.

 * @summary Delete a team vault
 */
export const deleteVault = ({ vaultId }: DeleteVaultPathParameters, options?: SecondParameter<typeof fetcher>) => {
    return fetcher<void>({ url: `/vaults/${vaultId}`, method: 'DELETE' }, options);
};

export const getDeleteVaultMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteVault>>, TError, { pathParams: DeleteVaultPathParameters }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteVault>>, TError, { pathParams: DeleteVaultPathParameters }, TContext> => {
    const mutationKey = ['deleteVault'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVault>>, { pathParams: DeleteVaultPathParameters }> = props => {
        const { pathParams } = props ?? {};

        return deleteVault(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteVaultMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVault>>>;

export type DeleteVaultMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Delete a team vault
 */
export const useDeleteVault = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteVault>>, TError, { pathParams: DeleteVaultPathParameters }, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof deleteVault>>, TError, { pathParams: DeleteVaultPathParameters }, TContext> => {
    const mutationOptions = getDeleteVaultMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Requires the editor role in the vault (a personal vault: its owner).
Every row creates a new secret in this vault. The columns `vaultId`,
`vaultName`, `personal`, `action` and `id` in the csv are ignored.
An admin keeps `createdBy` from the csv (missing values default to
the importer); any other editor is always the creator. Sharing (`groups`,
whitelisted users) is taken from the csv. `replaceSecrets` is not
supported. Validation errors follow `POST /secret-validations`.
A vault the caller cannot see is a 404.

 * @summary Import secrets from a csv file into one vault
 */
export const importVaultSecrets = (
    { vaultId }: ImportVaultSecretsPathParameters,
    importVaultSecretsRequestBodyBody: BodyType<ImportVaultSecretsRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    const formData = new FormData();
    if (importVaultSecretsRequestBodyBody.delimiter !== undefined) {
        formData.append(`delimiter`, importVaultSecretsRequestBodyBody.delimiter);
    }
    if (importVaultSecretsRequestBodyBody.format !== undefined) {
        formData.append(`format`, importVaultSecretsRequestBodyBody.format);
    }
    if (importVaultSecretsRequestBodyBody.secrets !== undefined) {
        formData.append(`secrets`, importVaultSecretsRequestBodyBody.secrets);
    }

    return fetcher<void>(
        { url: `/vaults/${vaultId}/secrets`, method: 'PATCH', headers: { 'Content-Type': 'multipart/form-data' }, data: formData },
        options,
    );
};

export const getImportVaultSecretsMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof importVaultSecrets>>,
        TError,
        { pathParams: ImportVaultSecretsPathParameters; data: BodyType<ImportVaultSecretsRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof importVaultSecrets>>,
    TError,
    { pathParams: ImportVaultSecretsPathParameters; data: BodyType<ImportVaultSecretsRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['importVaultSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof importVaultSecrets>>,
        { pathParams: ImportVaultSecretsPathParameters; data: BodyType<ImportVaultSecretsRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return importVaultSecrets(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ImportVaultSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof importVaultSecrets>>>;
export type ImportVaultSecretsMutationBody = BodyType<ImportVaultSecretsRequestBodyBody>;
export type ImportVaultSecretsMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | HttpError
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Import secrets from a csv file into one vault
 */
export const useImportVaultSecrets = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof importVaultSecrets>>,
            TError,
            { pathParams: ImportVaultSecretsPathParameters; data: BodyType<ImportVaultSecretsRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof importVaultSecrets>>,
    TError,
    { pathParams: ImportVaultSecretsPathParameters; data: BodyType<ImportVaultSecretsRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getImportVaultSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Exports only the secrets of the given vault. Requires the editor role
in a team vault, or ownership of a personal vault. The csv has the same
columns as the company-wide export, including `vaultId`, `vaultName`
and `personal`. The file name is `secrets-<vault-name>.csv` with the
vault name reduced to ascii. A vault the caller cannot see is a 404.

 * @summary Export the secrets of one vault to a csv file
 */
export const exportVaultSecrets = (
    { vaultId }: ExportVaultSecretsPathParameters,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<ExportSecretsResponseResponse>({ url: `/vaults/${vaultId}/secret-exports`, method: 'POST', signal }, options);
};

export const getExportVaultSecretsMutationOptions = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof exportVaultSecrets>>,
        TError,
        { pathParams: ExportVaultSecretsPathParameters },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof exportVaultSecrets>>,
    TError,
    { pathParams: ExportVaultSecretsPathParameters },
    TContext
> => {
    const mutationKey = ['exportVaultSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof exportVaultSecrets>>,
        { pathParams: ExportVaultSecretsPathParameters }
    > = props => {
        const { pathParams } = props ?? {};

        return exportVaultSecrets(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExportVaultSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof exportVaultSecrets>>>;

export type ExportVaultSecretsMutationError = ErrorType<
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Export the secrets of one vault to a csv file
 */
export const useExportVaultSecrets = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof exportVaultSecrets>>,
            TError,
            { pathParams: ExportVaultSecretsPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof exportVaultSecrets>>,
    TError,
    { pathParams: ExportVaultSecretsPathParameters },
    TContext
> => {
    const mutationOptions = getExportVaultSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Same checks and error report as `POST /secret-validations`, for the
editor of the vault. Rows flagged `personal` are accepted here because
every row lands in this vault.

 * @summary Validate a csv file before importing it into one vault
 */
export const validateVaultSecrets = (
    { vaultId }: ValidateVaultSecretsPathParameters,
    validateSecretsRequestBodyBody: BodyType<ValidateSecretsRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    const formData = new FormData();
    if (validateSecretsRequestBodyBody.delimiter !== undefined) {
        formData.append(`delimiter`, validateSecretsRequestBodyBody.delimiter);
    }
    if (validateSecretsRequestBodyBody.format !== undefined) {
        formData.append(`format`, validateSecretsRequestBodyBody.format);
    }
    if (validateSecretsRequestBodyBody.filename !== undefined) {
        formData.append(`filename`, validateSecretsRequestBodyBody.filename);
    }

    return fetcher<void>(
        {
            url: `/vaults/${vaultId}/secret-validations`,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData,
            signal,
        },
        options,
    );
};

export const getValidateVaultSecretsMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof validateVaultSecrets>>,
        TError,
        { pathParams: ValidateVaultSecretsPathParameters; data: BodyType<ValidateSecretsRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof validateVaultSecrets>>,
    TError,
    { pathParams: ValidateVaultSecretsPathParameters; data: BodyType<ValidateSecretsRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['validateVaultSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof validateVaultSecrets>>,
        { pathParams: ValidateVaultSecretsPathParameters; data: BodyType<ValidateSecretsRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return validateVaultSecrets(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ValidateVaultSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof validateVaultSecrets>>>;
export type ValidateVaultSecretsMutationBody = BodyType<ValidateSecretsRequestBodyBody>;
export type ValidateVaultSecretsMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | HttpError
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Validate a csv file before importing it into one vault
 */
export const useValidateVaultSecrets = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof validateVaultSecrets>>,
            TError,
            { pathParams: ValidateVaultSecretsPathParameters; data: BodyType<ValidateSecretsRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof validateVaultSecrets>>,
    TError,
    { pathParams: ValidateVaultSecretsPathParameters; data: BodyType<ValidateSecretsRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getValidateVaultSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update tag name on all secrets
 */
export const tagUpdate = (
    { tagName }: TagUpdatePathParameters,
    updateTagRequestBodyBody: BodyType<UpdateTagRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<TagUpdate200>(
        { url: `/tags/${tagName}`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: updateTagRequestBodyBody },
        options,
    );
};

export const getTagUpdateMutationOptions = <
    TError = ErrorType<
        | HttpError
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof tagUpdate>>,
        TError,
        { pathParams: TagUpdatePathParameters; data: BodyType<UpdateTagRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof tagUpdate>>,
    TError,
    { pathParams: TagUpdatePathParameters; data: BodyType<UpdateTagRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['tagUpdate'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof tagUpdate>>,
        { pathParams: TagUpdatePathParameters; data: BodyType<UpdateTagRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return tagUpdate(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type TagUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tagUpdate>>>;
export type TagUpdateMutationBody = BodyType<UpdateTagRequestBodyBody>;
export type TagUpdateMutationError = ErrorType<
    | HttpError
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update tag name on all secrets
 */
export const useTagUpdate = <
    TError = ErrorType<
        | HttpError
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof tagUpdate>>,
            TError,
            { pathParams: TagUpdatePathParameters; data: BodyType<UpdateTagRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof tagUpdate>>,
    TError,
    { pathParams: TagUpdatePathParameters; data: BodyType<UpdateTagRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getTagUpdateMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete tag from all secrets
 */
export const tagDelete = ({ tagName }: TagDeletePathParameters, options?: SecondParameter<typeof fetcher>) => {
    return fetcher<void>({ url: `/tags/${tagName}`, method: 'DELETE' }, options);
};

export const getTagDeleteMutationOptions = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof tagDelete>>, TError, { pathParams: TagDeletePathParameters }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof tagDelete>>, TError, { pathParams: TagDeletePathParameters }, TContext> => {
    const mutationKey = ['tagDelete'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagDelete>>, { pathParams: TagDeletePathParameters }> = props => {
        const { pathParams } = props ?? {};

        return tagDelete(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type TagDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof tagDelete>>>;

export type TagDeleteMutationError = ErrorType<
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Delete tag from all secrets
 */
export const useTagDelete = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof tagDelete>>, TError, { pathParams: TagDeletePathParameters }, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof tagDelete>>, TError, { pathParams: TagDeletePathParameters }, TContext> => {
    const mutationOptions = getTagDeleteMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Allow hidden group to be visible in search
 */
export const showGroupInSecrets = (
    { groupId }: ShowGroupInSecretsPathParameters,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<HiddenGroupsResponseResponse>({ url: `/groups/${groupId}/show`, method: 'POST', signal }, options);
};

export const getShowGroupInSecretsMutationOptions = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof showGroupInSecrets>>,
        TError,
        { pathParams: ShowGroupInSecretsPathParameters },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof showGroupInSecrets>>,
    TError,
    { pathParams: ShowGroupInSecretsPathParameters },
    TContext
> => {
    const mutationKey = ['showGroupInSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof showGroupInSecrets>>,
        { pathParams: ShowGroupInSecretsPathParameters }
    > = props => {
        const { pathParams } = props ?? {};

        return showGroupInSecrets(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ShowGroupInSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof showGroupInSecrets>>>;

export type ShowGroupInSecretsMutationError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Allow hidden group to be visible in search
 */
export const useShowGroupInSecrets = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof showGroupInSecrets>>,
            TError,
            { pathParams: ShowGroupInSecretsPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof showGroupInSecrets>>,
    TError,
    { pathParams: ShowGroupInSecretsPathParameters },
    TContext
> => {
    const mutationOptions = getShowGroupInSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove group from all secrets and hide from search
 */
export const hideGroupFromSecrets = (
    { groupId }: HideGroupFromSecretsPathParameters,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<HiddenGroupsResponseResponse>({ url: `/groups/${groupId}/hide`, method: 'POST', signal }, options);
};

export const getHideGroupFromSecretsMutationOptions = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof hideGroupFromSecrets>>,
        TError,
        { pathParams: HideGroupFromSecretsPathParameters },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof hideGroupFromSecrets>>,
    TError,
    { pathParams: HideGroupFromSecretsPathParameters },
    TContext
> => {
    const mutationKey = ['hideGroupFromSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof hideGroupFromSecrets>>,
        { pathParams: HideGroupFromSecretsPathParameters }
    > = props => {
        const { pathParams } = props ?? {};

        return hideGroupFromSecrets(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type HideGroupFromSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof hideGroupFromSecrets>>>;

export type HideGroupFromSecretsMutationError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Remove group from all secrets and hide from search
 */
export const useHideGroupFromSecrets = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof hideGroupFromSecrets>>,
            TError,
            { pathParams: HideGroupFromSecretsPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof hideGroupFromSecrets>>,
    TError,
    { pathParams: HideGroupFromSecretsPathParameters },
    TContext
> => {
    const mutationOptions = getHideGroupFromSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List user' groups
 */
export const groupsQuery = (params?: GroupsQueryParams, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<GroupsQuery200>({ url: `/groups-query`, method: 'GET', params, signal }, options);
};

export const getGroupsQueryQueryKey = (params?: GroupsQueryParams) => {
    return [`/groups-query`, ...(params ? [params] : [])] as const;
};

export const getGroupsQueryQueryOptions = <
    TData = Awaited<ReturnType<typeof groupsQuery>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: GroupsQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGroupsQueryQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupsQuery>>> = ({ signal }) => groupsQuery(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type GroupsQueryQueryResult = NonNullable<Awaited<ReturnType<typeof groupsQuery>>>;
export type GroupsQueryQueryError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function useGroupsQuery<
    TData = Awaited<ReturnType<typeof groupsQuery>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params: undefined | GroupsQueryParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, Awaited<ReturnType<typeof groupsQuery>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGroupsQuery<
    TData = Awaited<ReturnType<typeof groupsQuery>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: GroupsQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, Awaited<ReturnType<typeof groupsQuery>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGroupsQuery<
    TData = Awaited<ReturnType<typeof groupsQuery>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: GroupsQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List user' groups
 */

export function useGroupsQuery<
    TData = Awaited<ReturnType<typeof groupsQuery>>,
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
>(
    params?: GroupsQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsQuery>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGroupsQueryQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary List group members
 */
export const groupMembers = ({ groupId }: GroupMembersPathParameters, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<GroupMembersResponseResponse>({ url: `/groups/${groupId}/members`, method: 'GET', signal }, options);
};

export const getGroupMembersQueryKey = ({ groupId }: GroupMembersPathParameters) => {
    return [`/groups/${groupId}/members`] as const;
};

export const getGroupMembersQueryOptions = <
    TData = Awaited<ReturnType<typeof groupMembers>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    { groupId }: GroupMembersPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupMembers>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGroupMembersQueryKey({ groupId });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupMembers>>> = ({ signal }) =>
        groupMembers({ groupId }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!groupId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof groupMembers>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GroupMembersQueryResult = NonNullable<Awaited<ReturnType<typeof groupMembers>>>;
export type GroupMembersQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function useGroupMembers<
    TData = Awaited<ReturnType<typeof groupMembers>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: GroupMembersPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupMembers>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof groupMembers>>, TError, Awaited<ReturnType<typeof groupMembers>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGroupMembers<
    TData = Awaited<ReturnType<typeof groupMembers>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: GroupMembersPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupMembers>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof groupMembers>>, TError, Awaited<ReturnType<typeof groupMembers>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGroupMembers<
    TData = Awaited<ReturnType<typeof groupMembers>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: GroupMembersPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupMembers>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List group members
 */

export function useGroupMembers<
    TData = Awaited<ReturnType<typeof groupMembers>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    { groupId }: GroupMembersPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupMembers>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGroupMembersQueryOptions({ groupId }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary List contacts
 */
export const contactList = (params?: ContactListParams, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<UserObject[]>({ url: `/contacts`, method: 'GET', params, signal }, options);
};

export const getContactListQueryKey = (params?: ContactListParams) => {
    return [`/contacts`, ...(params ? [params] : [])] as const;
};

export const getContactListQueryOptions = <
    TData = Awaited<ReturnType<typeof contactList>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactListParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactList>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getContactListQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactList>>> = ({ signal }) => contactList(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof contactList>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ContactListQueryResult = NonNullable<Awaited<ReturnType<typeof contactList>>>;
export type ContactListQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function useContactList<
    TData = Awaited<ReturnType<typeof contactList>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params: undefined | ContactListParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactList>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof contactList>>, TError, Awaited<ReturnType<typeof contactList>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useContactList<
    TData = Awaited<ReturnType<typeof contactList>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactListParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactList>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof contactList>>, TError, Awaited<ReturnType<typeof contactList>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useContactList<
    TData = Awaited<ReturnType<typeof contactList>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactListParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactList>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List contacts
 */

export function useContactList<
    TData = Awaited<ReturnType<typeof contactList>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactListParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactList>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getContactListQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Query contacts
 */
export const contactQuery = (params?: ContactQueryParams, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ContactQuery200>({ url: `/contacts-query`, method: 'GET', params, signal }, options);
};

export const getContactQueryQueryKey = (params?: ContactQueryParams) => {
    return [`/contacts-query`, ...(params ? [params] : [])] as const;
};

export const getContactQueryQueryOptions = <
    TData = Awaited<ReturnType<typeof contactQuery>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactQuery>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getContactQueryQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactQuery>>> = ({ signal }) => contactQuery(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof contactQuery>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ContactQueryQueryResult = NonNullable<Awaited<ReturnType<typeof contactQuery>>>;
export type ContactQueryQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function useContactQuery<
    TData = Awaited<ReturnType<typeof contactQuery>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params: undefined | ContactQueryParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactQuery>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof contactQuery>>, TError, Awaited<ReturnType<typeof contactQuery>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useContactQuery<
    TData = Awaited<ReturnType<typeof contactQuery>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactQuery>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof contactQuery>>, TError, Awaited<ReturnType<typeof contactQuery>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useContactQuery<
    TData = Awaited<ReturnType<typeof contactQuery>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactQuery>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Query contacts
 */

export function useContactQuery<
    TData = Awaited<ReturnType<typeof contactQuery>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ContactQueryParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contactQuery>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getContactQueryQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Requires admin. The e1003 error report counts `parseSecretError`,
`invalidSecretError`, `invalidUserError`, `invalidGroupError` and
`personalSecretError` (rows flagged `personal = true`, which the
company-wide import skips), plus `invalidUserIds` and
`invalidGroupIds`.

 * @summary Validate csv file with secrets
 */
export const validateSecrets = (
    validateSecretsRequestBodyBody: BodyType<ValidateSecretsRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    const formData = new FormData();
    if (validateSecretsRequestBodyBody.delimiter !== undefined) {
        formData.append(`delimiter`, validateSecretsRequestBodyBody.delimiter);
    }
    if (validateSecretsRequestBodyBody.format !== undefined) {
        formData.append(`format`, validateSecretsRequestBodyBody.format);
    }
    if (validateSecretsRequestBodyBody.filename !== undefined) {
        formData.append(`filename`, validateSecretsRequestBodyBody.filename);
    }

    return fetcher<void>(
        { url: `/secret-validations`, method: 'POST', headers: { 'Content-Type': 'multipart/form-data' }, data: formData, signal },
        options,
    );
};

export const getValidateSecretsMutationOptions = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof validateSecrets>>,
        TError,
        { data: BodyType<ValidateSecretsRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof validateSecrets>>,
    TError,
    { data: BodyType<ValidateSecretsRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['validateSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof validateSecrets>>,
        { data: BodyType<ValidateSecretsRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return validateSecrets(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ValidateSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof validateSecrets>>>;
export type ValidateSecretsMutationBody = BodyType<ValidateSecretsRequestBodyBody>;
export type ValidateSecretsMutationError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Validate csv file with secrets
 */
export const useValidateSecrets = <
    TError = ErrorType<
        HttpError | UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof validateSecrets>>,
            TError,
            { data: BodyType<ValidateSecretsRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof validateSecrets>>, TError, { data: BodyType<ValidateSecretsRequestBodyBody> }, TContext> => {
    const mutationOptions = getValidateSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Company-wide export, requires admin. Secrets contained in personal
vaults are not included (admins have no access to personal vault
content). Every row carries the columns `vaultId`, `vaultName` and
`personal` (Passwd csv format version 5), so a re-import restores the
vault membership. Use `POST /vaults/{vaultId}/secret-exports` to
export one vault.

 * @summary Export secrets to a csv file
 */
export const exportSecrets = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ExportSecretsResponseResponse>({ url: `/secret-exports`, method: 'POST', signal }, options);
};

export const getExportSecretsMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof exportSecrets>>, TError, void, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof exportSecrets>>, TError, void, TContext> => {
    const mutationKey = ['exportSecrets'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportSecrets>>, void> = () => {
        return exportSecrets(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExportSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof exportSecrets>>>;

export type ExportSecretsMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Export secrets to a csv file
 */
export const useExportSecrets = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof exportSecrets>>, TError, void, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof exportSecrets>>, TError, void, TContext> => {
    const mutationOptions = getExportSecretsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Returns the password strength report with the affected secrets. Admins
only. The Starter plan returns 402 with error e2008 and exposes only
the counts from `GET /security-audit/summary`.

 * @summary Get secrets report
 */
export const secretsReport = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ReportSecretsResponseResponse>({ url: `/password-reports`, method: 'POST', signal }, options);
};

export const getSecretsReportMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof secretsReport>>, TError, void, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof secretsReport>>, TError, void, TContext> => {
    const mutationKey = ['secretsReport'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof secretsReport>>, void> = () => {
        return secretsReport(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type SecretsReportMutationResult = NonNullable<Awaited<ReturnType<typeof secretsReport>>>;

export type SecretsReportMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | HttpError
    | ForbiddenErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Get secrets report
 */
export const useSecretsReport = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | HttpError
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof secretsReport>>, TError, void, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof secretsReport>>, TError, void, TContext> => {
    const mutationOptions = getSecretsReportMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Returns aggregated security-audit counts over the same password secrets
that `GET /secrets` returns to the caller, including the Starter plan
record limit. Admins get counts over all secrets they can access. Other
users get counts over their own accessible secrets. The response
contains counts only, never the affected secrets. Secrets with
`ignoreSecurityReport` are excluded from the problem counts. For users
without the admin role, `duplicities` skips secrets where the user
holds only a limited or passkey-only permission.

 * @summary Get security-audit summary counts
 */
export const securityAuditSummary = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<SecurityAuditSummaryResponseResponse>({ url: `/security-audit/summary`, method: 'GET', signal }, options);
};

export const getSecurityAuditSummaryQueryKey = () => {
    return [`/security-audit/summary`] as const;
};

export const getSecurityAuditSummaryQueryOptions = <
    TData = Awaited<ReturnType<typeof securityAuditSummary>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof securityAuditSummary>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSecurityAuditSummaryQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityAuditSummary>>> = ({ signal }) =>
        securityAuditSummary(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof securityAuditSummary>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type SecurityAuditSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof securityAuditSummary>>>;
export type SecurityAuditSummaryQueryError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>;

export function useSecurityAuditSummary<
    TData = Awaited<ReturnType<typeof securityAuditSummary>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof securityAuditSummary>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof securityAuditSummary>>,
                    TError,
                    Awaited<ReturnType<typeof securityAuditSummary>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSecurityAuditSummary<
    TData = Awaited<ReturnType<typeof securityAuditSummary>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof securityAuditSummary>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof securityAuditSummary>>,
                    TError,
                    Awaited<ReturnType<typeof securityAuditSummary>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSecurityAuditSummary<
    TData = Awaited<ReturnType<typeof securityAuditSummary>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof securityAuditSummary>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get security-audit summary counts
 */

export function useSecurityAuditSummary<
    TData = Awaited<ReturnType<typeof securityAuditSummary>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof securityAuditSummary>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getSecurityAuditSummaryQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Endpoint to trigger Have I Been Pwned check. Updates secrets with pwned status.
 */
export const hibpCheck = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<void>({ url: `/cron/hibp-check`, method: 'POST', signal }, options);
};

export const getHibpCheckMutationOptions = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof hibpCheck>>, TError, void, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof hibpCheck>>, TError, void, TContext> => {
    const mutationKey = ['hibpCheck'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof hibpCheck>>, void> = () => {
        return hibpCheck(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type HibpCheckMutationResult = NonNullable<Awaited<ReturnType<typeof hibpCheck>>>;

export type HibpCheckMutationError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Endpoint to trigger Have I Been Pwned check. Updates secrets with pwned status.
 */
export const useHibpCheck = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof hibpCheck>>, TError, void, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof hibpCheck>>, TError, void, TContext> => {
    const mutationOptions = getHibpCheckMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Record user's feedback
 */
export const collectFeedback = (
    collectFeedbackRequestBodyBody: BodyType<CollectFeedbackRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<CollectFeedbackResponseResponse>(
        { url: `/feedback`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: collectFeedbackRequestBodyBody, signal },
        options,
    );
};

export const getCollectFeedbackMutationOptions = <
    TError = ErrorType<HttpError | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof collectFeedback>>,
        TError,
        { data: BodyType<CollectFeedbackRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof collectFeedback>>,
    TError,
    { data: BodyType<CollectFeedbackRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['collectFeedback'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof collectFeedback>>,
        { data: BodyType<CollectFeedbackRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return collectFeedback(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type CollectFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof collectFeedback>>>;
export type CollectFeedbackMutationBody = BodyType<CollectFeedbackRequestBodyBody>;
export type CollectFeedbackMutationError = ErrorType<
    HttpError | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Record user's feedback
 */
export const useCollectFeedback = <
    TError = ErrorType<HttpError | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof collectFeedback>>,
            TError,
            { data: BodyType<CollectFeedbackRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof collectFeedback>>, TError, { data: BodyType<CollectFeedbackRequestBodyBody> }, TContext> => {
    const mutationOptions = getCollectFeedbackMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a checkout URL for the SaaS service.
 * @summary Generate a checkout URL
 */
export const createCheckout = (
    checkoutRequestBodyBody: BodyType<CheckoutRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<CheckoutResponseBodyResponse>(
        { url: `/saas/checkout`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: checkoutRequestBodyBody, signal },
        options,
    );
};

export const getCreateCheckoutMutationOptions = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createCheckout>>,
        TError,
        { data: BodyType<CheckoutRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof createCheckout>>, TError, { data: BodyType<CheckoutRequestBodyBody> }, TContext> => {
    const mutationKey = ['createCheckout'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCheckout>>, { data: BodyType<CheckoutRequestBodyBody> }> = props => {
        const { data } = props ?? {};

        return createCheckout(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createCheckout>>>;
export type CreateCheckoutMutationBody = BodyType<CheckoutRequestBodyBody>;
export type CreateCheckoutMutationError = ErrorType<
    BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Generate a checkout URL
 */
export const useCreateCheckout = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof createCheckout>>,
            TError,
            { data: BodyType<CheckoutRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createCheckout>>, TError, { data: BodyType<CheckoutRequestBodyBody> }, TContext> => {
    const mutationOptions = getCreateCheckoutMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reset sandbox secrets
 */
export const resetSandbox = (params?: ResetSandboxParams, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<SandboxResetResponseResponse>({ url: `/sandbox-reset`, method: 'GET', params, signal }, options);
};

export const getResetSandboxQueryKey = (params?: ResetSandboxParams) => {
    return [`/sandbox-reset`, ...(params ? [params] : [])] as const;
};

export const getResetSandboxQueryOptions = <TData = Awaited<ReturnType<typeof resetSandbox>>, TError = ErrorType<unknown>>(
    params?: ResetSandboxParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getResetSandboxQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof resetSandbox>>> = ({ signal }) => resetSandbox(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ResetSandboxQueryResult = NonNullable<Awaited<ReturnType<typeof resetSandbox>>>;
export type ResetSandboxQueryError = ErrorType<unknown>;

export function useResetSandbox<TData = Awaited<ReturnType<typeof resetSandbox>>, TError = ErrorType<unknown>>(
    params: undefined | ResetSandboxParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, Awaited<ReturnType<typeof resetSandbox>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useResetSandbox<TData = Awaited<ReturnType<typeof resetSandbox>>, TError = ErrorType<unknown>>(
    params?: ResetSandboxParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, Awaited<ReturnType<typeof resetSandbox>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useResetSandbox<TData = Awaited<ReturnType<typeof resetSandbox>>, TError = ErrorType<unknown>>(
    params?: ResetSandboxParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reset sandbox secrets
 */

export function useResetSandbox<TData = Awaited<ReturnType<typeof resetSandbox>>, TError = ErrorType<unknown>>(
    params?: ResetSandboxParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resetSandbox>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getResetSandboxQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Save user's contact email
 */
export const saveSandboxContact = (
    sandboxContactsRequestBodyBody: BodyType<SandboxContactsRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<SandboxContactsResponseResponse>(
        {
            url: `/sandbox-contacts`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: sandboxContactsRequestBodyBody,
            signal,
        },
        options,
    );
};

export const getSaveSandboxContactMutationOptions = <TError = ErrorType<HttpError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof saveSandboxContact>>,
        TError,
        { data: BodyType<SandboxContactsRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof saveSandboxContact>>,
    TError,
    { data: BodyType<SandboxContactsRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['saveSandboxContact'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof saveSandboxContact>>,
        { data: BodyType<SandboxContactsRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return saveSandboxContact(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type SaveSandboxContactMutationResult = NonNullable<Awaited<ReturnType<typeof saveSandboxContact>>>;
export type SaveSandboxContactMutationBody = BodyType<SandboxContactsRequestBodyBody>;
export type SaveSandboxContactMutationError = ErrorType<HttpError>;

/**
 * @summary Save user's contact email
 */
export const useSaveSandboxContact = <TError = ErrorType<HttpError>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof saveSandboxContact>>,
            TError,
            { data: BodyType<SandboxContactsRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof saveSandboxContact>>,
    TError,
    { data: BodyType<SandboxContactsRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getSaveSandboxContactMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get organization detail - Saas only
 */
export const organizationDetail = (
    { domain }: OrganizationDetailPathParameters,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<OrganizationDetailResponseResponse>({ url: `/admin/organizations/${domain}`, method: 'GET', signal }, options);
};

export const getOrganizationDetailQueryKey = ({ domain }: OrganizationDetailPathParameters) => {
    return [`/admin/organizations/${domain}`] as const;
};

export const getOrganizationDetailQueryOptions = <TData = Awaited<ReturnType<typeof organizationDetail>>, TError = ErrorType<HttpError>>(
    { domain }: OrganizationDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getOrganizationDetailQueryKey({ domain });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationDetail>>> = ({ signal }) =>
        organizationDetail({ domain }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!domain, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof organizationDetail>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OrganizationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof organizationDetail>>>;
export type OrganizationDetailQueryError = ErrorType<HttpError>;

export function useOrganizationDetail<TData = Awaited<ReturnType<typeof organizationDetail>>, TError = ErrorType<HttpError>>(
    pathParams: OrganizationDetailPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationDetail>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof organizationDetail>>,
                    TError,
                    Awaited<ReturnType<typeof organizationDetail>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationDetail<TData = Awaited<ReturnType<typeof organizationDetail>>, TError = ErrorType<HttpError>>(
    pathParams: OrganizationDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationDetail>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof organizationDetail>>,
                    TError,
                    Awaited<ReturnType<typeof organizationDetail>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationDetail<TData = Awaited<ReturnType<typeof organizationDetail>>, TError = ErrorType<HttpError>>(
    pathParams: OrganizationDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get organization detail - Saas only
 */

export function useOrganizationDetail<TData = Awaited<ReturnType<typeof organizationDetail>>, TError = ErrorType<HttpError>>(
    { domain }: OrganizationDetailPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getOrganizationDetailQueryOptions({ domain }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get settings for workspace
 */
export const getSettings = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<SettingsResponseResponse>({ url: `/settings`, method: 'GET', signal }, options);
};

export const getGetSettingsQueryKey = () => {
    return [`/settings`] as const;
};

export const getGetSettingsQueryOptions = <
    TData = Awaited<ReturnType<typeof getSettings>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>;
export type GetSettingsQueryError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>;

export function useGetSettings<
    TData = Awaited<ReturnType<typeof getSettings>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof getSettings>>, TError, Awaited<ReturnType<typeof getSettings>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSettings<
    TData = Awaited<ReturnType<typeof getSettings>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof getSettings>>, TError, Awaited<ReturnType<typeof getSettings>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSettings<
    TData = Awaited<ReturnType<typeof getSettings>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get settings for workspace
 */

export function useGetSettings<
    TData = Awaited<ReturnType<typeof getSettings>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetSettingsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Set settings for workspace
 */
export const putSettings = (settingsRequestBodyBody: BodyType<SettingsRequestBodyBody>, options?: SecondParameter<typeof fetcher>) => {
    return fetcher<AdminSettingsResponseResponse>(
        { url: `/settings`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: settingsRequestBodyBody },
        options,
    );
};

export const getPutSettingsMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof putSettings>>, TError, { data: BodyType<SettingsRequestBodyBody> }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof putSettings>>, TError, { data: BodyType<SettingsRequestBodyBody> }, TContext> => {
    const mutationKey = ['putSettings'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSettings>>, { data: BodyType<SettingsRequestBodyBody> }> = props => {
        const { data } = props ?? {};

        return putSettings(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putSettings>>>;
export type PutSettingsMutationBody = BodyType<SettingsRequestBodyBody>;
export type PutSettingsMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Set settings for workspace
 */
export const usePutSettings = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putSettings>>,
            TError,
            { data: BodyType<SettingsRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof putSettings>>, TError, { data: BodyType<SettingsRequestBodyBody> }, TContext> => {
    const mutationOptions = getPutSettingsMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get settings for workspace with admin properties
 */
export const getSettingsAdmin = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<AdminSettingsResponseResponse>({ url: `/settings/admin`, method: 'GET', signal }, options);
};

export const getGetSettingsAdminQueryKey = () => {
    return [`/settings/admin`] as const;
};

export const getGetSettingsAdminQueryOptions = <
    TData = Awaited<ReturnType<typeof getSettingsAdmin>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsAdmin>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSettingsAdminQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsAdmin>>> = ({ signal }) => getSettingsAdmin(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getSettingsAdmin>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type GetSettingsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsAdmin>>>;
export type GetSettingsAdminQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
>;

export function useGetSettingsAdmin<
    TData = Awaited<ReturnType<typeof getSettingsAdmin>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsAdmin>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSettingsAdmin>>,
                    TError,
                    Awaited<ReturnType<typeof getSettingsAdmin>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSettingsAdmin<
    TData = Awaited<ReturnType<typeof getSettingsAdmin>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsAdmin>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getSettingsAdmin>>,
                    TError,
                    Awaited<ReturnType<typeof getSettingsAdmin>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSettingsAdmin<
    TData = Awaited<ReturnType<typeof getSettingsAdmin>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsAdmin>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get settings for workspace with admin properties
 */

export function useGetSettingsAdmin<
    TData = Awaited<ReturnType<typeof getSettingsAdmin>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsAdmin>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetSettingsAdminQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get settings with pricing from payment gateway
 */
export const getAdminPricing = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<AdminPricingSettingsResponseResponse>({ url: `/settings/admin-pricing`, method: 'GET', signal }, options);
};

export const getGetAdminPricingQueryKey = () => {
    return [`/settings/admin-pricing`] as const;
};

export const getGetAdminPricingQueryOptions = <
    TData = Awaited<ReturnType<typeof getAdminPricing>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPricing>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAdminPricingQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPricing>>> = ({ signal }) => getAdminPricing(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getAdminPricing>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type GetAdminPricingQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPricing>>>;
export type GetAdminPricingQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse
>;

export function useGetAdminPricing<
    TData = Awaited<ReturnType<typeof getAdminPricing>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPricing>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof getAdminPricing>>, TError, Awaited<ReturnType<typeof getAdminPricing>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminPricing<
    TData = Awaited<ReturnType<typeof getAdminPricing>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPricing>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getAdminPricing>>,
                    TError,
                    Awaited<ReturnType<typeof getAdminPricing>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminPricing<
    TData = Awaited<ReturnType<typeof getAdminPricing>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPricing>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get settings with pricing from payment gateway
 */

export function useGetAdminPricing<
    TData = Awaited<ReturnType<typeof getAdminPricing>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | HttpError | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPricing>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetAdminPricingQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Returns the state of the 30-day browser extension trial of a SaaS organization without an active subscription. The trial starts with the creation of the organization. When the trial is over, the API rejects every other bearer-token request from the browser extension with 402 and error e2009. The API recognizes the browser extension by the `passwd-platform` header with the `_extension` suffix. The exceptions are `GET /`, `GET /me`, `GET /settings`, `GET /trial/extension`, `POST /saas/checkout` and `POST /administration/request-access`. The error carries `errorData.trialDeadline` and `errorData.createdAt` as date-time strings.
 * @summary Find if user has extension trial allowed
 */
export const extensionTrialDetail = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ExtensionTrialResponseResponse>({ url: `/trial/extension`, method: 'GET', signal }, options);
};

export const getExtensionTrialDetailQueryKey = () => {
    return [`/trial/extension`] as const;
};

export const getExtensionTrialDetailQueryOptions = <
    TData = Awaited<ReturnType<typeof extensionTrialDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof extensionTrialDetail>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getExtensionTrialDetailQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof extensionTrialDetail>>> = ({ signal }) =>
        extensionTrialDetail(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof extensionTrialDetail>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ExtensionTrialDetailQueryResult = NonNullable<Awaited<ReturnType<typeof extensionTrialDetail>>>;
export type ExtensionTrialDetailQueryError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>;

export function useExtensionTrialDetail<
    TData = Awaited<ReturnType<typeof extensionTrialDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof extensionTrialDetail>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof extensionTrialDetail>>,
                    TError,
                    Awaited<ReturnType<typeof extensionTrialDetail>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExtensionTrialDetail<
    TData = Awaited<ReturnType<typeof extensionTrialDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof extensionTrialDetail>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof extensionTrialDetail>>,
                    TError,
                    Awaited<ReturnType<typeof extensionTrialDetail>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExtensionTrialDetail<
    TData = Awaited<ReturnType<typeof extensionTrialDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof extensionTrialDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find if user has extension trial allowed
 */

export function useExtensionTrialDetail<
    TData = Awaited<ReturnType<typeof extensionTrialDetail>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof extensionTrialDetail>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getExtensionTrialDetailQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Set firefox login
 */
export const firefoxLogin = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<FirefoxLoginResponseResponse>({ url: `/extension/firefox-login`, method: 'POST', signal }, options);
};

export const getFirefoxLoginMutationOptions = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof firefoxLogin>>, TError, void, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof firefoxLogin>>, TError, void, TContext> => {
    const mutationKey = ['firefoxLogin'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof firefoxLogin>>, void> = () => {
        return firefoxLogin(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type FirefoxLoginMutationResult = NonNullable<Awaited<ReturnType<typeof firefoxLogin>>>;

export type FirefoxLoginMutationError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>;

/**
 * @summary Set firefox login
 */
export const useFirefoxLogin = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof firefoxLogin>>, TError, void, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof firefoxLogin>>, TError, void, TContext> => {
    const mutationOptions = getFirefoxLoginMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new passkey credential for the specified secret
 * @summary Register a new passkey
 */
export const registerPasskey = (
    publicKeyCredentialCreationOptions: BodyType<PublicKeyCredentialCreationOptions>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<AttestationResponse>(
        {
            url: `/passkeys/register`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: publicKeyCredentialCreationOptions,
            signal,
        },
        options,
    );
};

export const getRegisterPasskeyMutationOptions = <
    TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof registerPasskey>>,
        TError,
        { data: BodyType<PublicKeyCredentialCreationOptions> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof registerPasskey>>,
    TError,
    { data: BodyType<PublicKeyCredentialCreationOptions> },
    TContext
> => {
    const mutationKey = ['registerPasskey'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof registerPasskey>>,
        { data: BodyType<PublicKeyCredentialCreationOptions> }
    > = props => {
        const { data } = props ?? {};

        return registerPasskey(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type RegisterPasskeyMutationResult = NonNullable<Awaited<ReturnType<typeof registerPasskey>>>;
export type RegisterPasskeyMutationBody = BodyType<PublicKeyCredentialCreationOptions>;
export type RegisterPasskeyMutationError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>;

/**
 * @summary Register a new passkey
 */
export const useRegisterPasskey = <TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof registerPasskey>>,
            TError,
            { data: BodyType<PublicKeyCredentialCreationOptions> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof registerPasskey>>,
    TError,
    { data: BodyType<PublicKeyCredentialCreationOptions> },
    TContext
> => {
    const mutationOptions = getRegisterPasskeyMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Authenticates a user using their passkey
 * @summary Authenticate with passkey
 */
export const authenticatePasskey = (
    { secretId }: AuthenticatePasskeyPathParameters,
    publicKeyCredentialGetOptions: BodyType<PublicKeyCredentialGetOptions>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<AssertionResponse>(
        {
            url: `/secrets/${secretId}/authenticate-passkey`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: publicKeyCredentialGetOptions,
            signal,
        },
        options,
    );
};

export const getAuthenticatePasskeyMutationOptions = <
    TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof authenticatePasskey>>,
        TError,
        { pathParams: AuthenticatePasskeyPathParameters; data: BodyType<PublicKeyCredentialGetOptions> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof authenticatePasskey>>,
    TError,
    { pathParams: AuthenticatePasskeyPathParameters; data: BodyType<PublicKeyCredentialGetOptions> },
    TContext
> => {
    const mutationKey = ['authenticatePasskey'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof authenticatePasskey>>,
        { pathParams: AuthenticatePasskeyPathParameters; data: BodyType<PublicKeyCredentialGetOptions> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return authenticatePasskey(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type AuthenticatePasskeyMutationResult = NonNullable<Awaited<ReturnType<typeof authenticatePasskey>>>;
export type AuthenticatePasskeyMutationBody = BodyType<PublicKeyCredentialGetOptions>;
export type AuthenticatePasskeyMutationError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>;

/**
 * @summary Authenticate with passkey
 */
export const useAuthenticatePasskey = <TError = ErrorType<HttpError | PreconditionRequiredErrorResponseResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof authenticatePasskey>>,
            TError,
            { pathParams: AuthenticatePasskeyPathParameters; data: BodyType<PublicKeyCredentialGetOptions> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof authenticatePasskey>>,
    TError,
    { pathParams: AuthenticatePasskeyPathParameters; data: BodyType<PublicKeyCredentialGetOptions> },
    TContext
> => {
    const mutationOptions = getAuthenticatePasskeyMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get user administration settings
 */
export const listUsersAdministration = (
    params?: ListUsersAdministrationParams,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<UserAdministrationResponseResponse>({ url: `/administration/users`, method: 'GET', params, signal }, options);
};

export const getListUsersAdministrationQueryKey = (params?: ListUsersAdministrationParams) => {
    return [`/administration/users`, ...(params ? [params] : [])] as const;
};

export const getListUsersAdministrationQueryOptions = <
    TData = Awaited<ReturnType<typeof listUsersAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListUsersAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListUsersAdministrationQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsersAdministration>>> = ({ signal }) =>
        listUsersAdministration(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof listUsersAdministration>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ListUsersAdministrationQueryResult = NonNullable<Awaited<ReturnType<typeof listUsersAdministration>>>;
export type ListUsersAdministrationQueryError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>;

export function useListUsersAdministration<
    TData = Awaited<ReturnType<typeof listUsersAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params: undefined | ListUsersAdministrationParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAdministration>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof listUsersAdministration>>,
                    TError,
                    Awaited<ReturnType<typeof listUsersAdministration>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUsersAdministration<
    TData = Awaited<ReturnType<typeof listUsersAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListUsersAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAdministration>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof listUsersAdministration>>,
                    TError,
                    Awaited<ReturnType<typeof listUsersAdministration>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUsersAdministration<
    TData = Awaited<ReturnType<typeof listUsersAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListUsersAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user administration settings
 */

export function useListUsersAdministration<
    TData = Awaited<ReturnType<typeof listUsersAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListUsersAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getListUsersAdministrationQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Update user administration settings
 */
export const updateUsersAdministration = (
    updateUsersAdministrationBody: BodyType<UpdateUsersAdministrationBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<UpdateUserResponseResponse>(
        {
            url: `/administration/users`,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            data: updateUsersAdministrationBody,
        },
        options,
    );
};

export const getUpdateUsersAdministrationMutationOptions = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateUsersAdministration>>,
        TError,
        { data: BodyType<UpdateUsersAdministrationBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateUsersAdministration>>,
    TError,
    { data: BodyType<UpdateUsersAdministrationBody> },
    TContext
> => {
    const mutationKey = ['updateUsersAdministration'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateUsersAdministration>>,
        { data: BodyType<UpdateUsersAdministrationBody> }
    > = props => {
        const { data } = props ?? {};

        return updateUsersAdministration(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateUsersAdministrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateUsersAdministration>>>;
export type UpdateUsersAdministrationMutationBody = BodyType<UpdateUsersAdministrationBody>;
export type UpdateUsersAdministrationMutationError = ErrorType<
    BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update user administration settings
 */
export const useUpdateUsersAdministration = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof updateUsersAdministration>>,
            TError,
            { data: BodyType<UpdateUsersAdministrationBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof updateUsersAdministration>>,
    TError,
    { data: BodyType<UpdateUsersAdministrationBody> },
    TContext
> => {
    const mutationOptions = getUpdateUsersAdministrationMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get group administration settings
 */
export const listGroupsAdministration = (
    params?: ListGroupsAdministrationParams,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<ListGroupAdministrationResponseResponse>({ url: `/administration/groups`, method: 'GET', params, signal }, options);
};

export const getListGroupsAdministrationQueryKey = (params?: ListGroupsAdministrationParams) => {
    return [`/administration/groups`, ...(params ? [params] : [])] as const;
};

export const getListGroupsAdministrationQueryOptions = <
    TData = Awaited<ReturnType<typeof listGroupsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListGroupsAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListGroupsAdministrationQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupsAdministration>>> = ({ signal }) =>
        listGroupsAdministration(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof listGroupsAdministration>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListGroupsAdministrationQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupsAdministration>>>;
export type ListGroupsAdministrationQueryError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>;

export function useListGroupsAdministration<
    TData = Awaited<ReturnType<typeof listGroupsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params: undefined | ListGroupsAdministrationParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsAdministration>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof listGroupsAdministration>>,
                    TError,
                    Awaited<ReturnType<typeof listGroupsAdministration>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGroupsAdministration<
    TData = Awaited<ReturnType<typeof listGroupsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListGroupsAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsAdministration>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof listGroupsAdministration>>,
                    TError,
                    Awaited<ReturnType<typeof listGroupsAdministration>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGroupsAdministration<
    TData = Awaited<ReturnType<typeof listGroupsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListGroupsAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get group administration settings
 */

export function useListGroupsAdministration<
    TData = Awaited<ReturnType<typeof listGroupsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: ListGroupsAdministrationParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupsAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getListGroupsAdministrationQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Update group administration settings
 */
export const updateGroupsAdministration = (
    updateGroupsAdministrationBody: BodyType<UpdateGroupsAdministrationBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<UpdateGroupResponseResponse>(
        {
            url: `/administration/groups`,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            data: updateGroupsAdministrationBody,
        },
        options,
    );
};

export const getUpdateGroupsAdministrationMutationOptions = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateGroupsAdministration>>,
        TError,
        { data: BodyType<UpdateGroupsAdministrationBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateGroupsAdministration>>,
    TError,
    { data: BodyType<UpdateGroupsAdministrationBody> },
    TContext
> => {
    const mutationKey = ['updateGroupsAdministration'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateGroupsAdministration>>,
        { data: BodyType<UpdateGroupsAdministrationBody> }
    > = props => {
        const { data } = props ?? {};

        return updateGroupsAdministration(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateGroupsAdministrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroupsAdministration>>>;
export type UpdateGroupsAdministrationMutationBody = BodyType<UpdateGroupsAdministrationBody>;
export type UpdateGroupsAdministrationMutationError = ErrorType<
    BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update group administration settings
 */
export const useUpdateGroupsAdministration = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof updateGroupsAdministration>>,
            TError,
            { data: BodyType<UpdateGroupsAdministrationBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof updateGroupsAdministration>>,
    TError,
    { data: BodyType<UpdateGroupsAdministrationBody> },
    TContext
> => {
    const mutationOptions = getUpdateGroupsAdministrationMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Request access to application
 */
export const requestUserAccess = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<void>({ url: `/administration/request-access`, method: 'POST', signal }, options);
};

export const getRequestUserAccessMutationOptions = <TError = ErrorType<UnauthorizedErrorResponseResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof requestUserAccess>>, TError, void, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof requestUserAccess>>, TError, void, TContext> => {
    const mutationKey = ['requestUserAccess'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUserAccess>>, void> = () => {
        return requestUserAccess(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type RequestUserAccessMutationResult = NonNullable<Awaited<ReturnType<typeof requestUserAccess>>>;

export type RequestUserAccessMutationError = ErrorType<UnauthorizedErrorResponseResponse>;

/**
 * @summary Request access to application
 */
export const useRequestUserAccess = <TError = ErrorType<UnauthorizedErrorResponseResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<typeof requestUserAccess>>, TError, void, TContext>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof requestUserAccess>>, TError, void, TContext> => {
    const mutationOptions = getRequestUserAccessMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Admin-only. Lists every user's personal vault with its secret count and the
owner's access status, so an admin can find and clean up offboarded users'
vaults. Personal vaults are otherwise invisible to admins, so this is the
only surface that exposes them.

 * @summary List personal vaults for administration
 */
export const listPersonalVaultsAdministration = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ListPersonalVaultsAdministrationResponseResponse>({ url: `/administration/vaults`, method: 'GET', signal }, options);
};

export const getListPersonalVaultsAdministrationQueryKey = () => {
    return [`/administration/vaults`] as const;
};

export const getListPersonalVaultsAdministrationQueryOptions = <
    TData = Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalVaultsAdministration>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListPersonalVaultsAdministrationQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalVaultsAdministration>>> = ({ signal }) =>
        listPersonalVaultsAdministration(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPersonalVaultsAdministrationQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalVaultsAdministration>>>;
export type ListPersonalVaultsAdministrationQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function useListPersonalVaultsAdministration<
    TData = Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalVaultsAdministration>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
                    TError,
                    Awaited<ReturnType<typeof listPersonalVaultsAdministration>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPersonalVaultsAdministration<
    TData = Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalVaultsAdministration>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
                    TError,
                    Awaited<ReturnType<typeof listPersonalVaultsAdministration>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPersonalVaultsAdministration<
    TData = Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalVaultsAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List personal vaults for administration
 */

export function useListPersonalVaultsAdministration<
    TData = Awaited<ReturnType<typeof listPersonalVaultsAdministration>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalVaultsAdministration>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getListPersonalVaultsAdministrationQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Admin-only. Deletes a personal vault only when its owner is inactive
(offboarded); deleting an active user's personal vault is rejected with 409.
Secrets in the vault are not deleted — their vaultId is cleared, mirroring
team-vault deletion.

 * @summary Delete an offboarded user's personal vault
 */
export const deletePersonalVaultAdministration = (
    { vaultId }: DeletePersonalVaultAdministrationPathParameters,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<void>({ url: `/administration/vaults/${vaultId}`, method: 'DELETE' }, options);
};

export const getDeletePersonalVaultAdministrationMutationOptions = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | HttpError
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deletePersonalVaultAdministration>>,
        TError,
        { pathParams: DeletePersonalVaultAdministrationPathParameters },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deletePersonalVaultAdministration>>,
    TError,
    { pathParams: DeletePersonalVaultAdministrationPathParameters },
    TContext
> => {
    const mutationKey = ['deletePersonalVaultAdministration'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deletePersonalVaultAdministration>>,
        { pathParams: DeletePersonalVaultAdministrationPathParameters }
    > = props => {
        const { pathParams } = props ?? {};

        return deletePersonalVaultAdministration(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeletePersonalVaultAdministrationMutationResult = NonNullable<Awaited<ReturnType<typeof deletePersonalVaultAdministration>>>;

export type DeletePersonalVaultAdministrationMutationError = ErrorType<
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | HttpError
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Delete an offboarded user's personal vault
 */
export const useDeletePersonalVaultAdministration = <
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | HttpError
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deletePersonalVaultAdministration>>,
            TError,
            { pathParams: DeletePersonalVaultAdministrationPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deletePersonalVaultAdministration>>,
    TError,
    { pathParams: DeletePersonalVaultAdministrationPathParameters },
    TContext
> => {
    const mutationOptions = getDeletePersonalVaultAdministrationMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all API keys for the authenticated user
 */
export const listApiKeys = (options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ListApiKeysResponseResponse>({ url: `/api-keys`, method: 'GET', signal }, options);
};

export const getListApiKeysQueryKey = () => {
    return [`/api-keys`] as const;
};

export const getListApiKeysQueryOptions = <
    TData = Awaited<ReturnType<typeof listApiKeys>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListApiKeysQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiKeys>>> = ({ signal }) => listApiKeys(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type ListApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listApiKeys>>>;
export type ListApiKeysQueryError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>;

export function useListApiKeys<
    TData = Awaited<ReturnType<typeof listApiKeys>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, Awaited<ReturnType<typeof listApiKeys>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListApiKeys<
    TData = Awaited<ReturnType<typeof listApiKeys>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, Awaited<ReturnType<typeof listApiKeys>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListApiKeys<
    TData = Awaited<ReturnType<typeof listApiKeys>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all API keys for the authenticated user
 */

export function useListApiKeys<
    TData = Awaited<ReturnType<typeof listApiKeys>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getListApiKeysQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Generate a new API key
 */
export const createApiKey = (
    createApiKeyRequestBodyBody: BodyType<CreateApiKeyRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<CreateApiKeyResponseResponse>(
        { url: `/api-keys`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: createApiKeyRequestBodyBody, signal },
        options,
    );
};

export const getCreateApiKeyMutationOptions = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createApiKey>>,
        TError,
        { data: BodyType<CreateApiKeyRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError, { data: BodyType<CreateApiKeyRequestBodyBody> }, TContext> => {
    const mutationKey = ['createApiKey'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createApiKey>>,
        { data: BodyType<CreateApiKeyRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return createApiKey(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createApiKey>>>;
export type CreateApiKeyMutationBody = BodyType<CreateApiKeyRequestBodyBody>;
export type CreateApiKeyMutationError = ErrorType<
    BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Generate a new API key
 */
export const useCreateApiKey = <
    TError = ErrorType<BadRequestErrorResponseResponse | UnauthorizedErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof createApiKey>>,
            TError,
            { data: BodyType<CreateApiKeyRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createApiKey>>, TError, { data: BodyType<CreateApiKeyRequestBodyBody> }, TContext> => {
    const mutationOptions = getCreateApiKeyMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get API key detail
 */
export const getApiKey = ({ apiKeyId }: GetApiKeyPathParameters, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<GetApiKeyResponseResponse>({ url: `/api-keys/${apiKeyId}`, method: 'GET', signal }, options);
};

export const getGetApiKeyQueryKey = ({ apiKeyId }: GetApiKeyPathParameters) => {
    return [`/api-keys/${apiKeyId}`] as const;
};

export const getGetApiKeyQueryOptions = <
    TData = Awaited<ReturnType<typeof getApiKey>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    { apiKeyId }: GetApiKeyPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiKey>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetApiKeyQueryKey({ apiKeyId });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiKey>>> = ({ signal }) => getApiKey({ apiKeyId }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!apiKeyId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getApiKey>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiKey>>>;
export type GetApiKeyQueryError = ErrorType<
    | UnauthorizedErrorResponseResponse
    | ForbiddenErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

export function useGetApiKey<
    TData = Awaited<ReturnType<typeof getApiKey>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: GetApiKeyPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiKey>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiKey>>, TError, Awaited<ReturnType<typeof getApiKey>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiKey<
    TData = Awaited<ReturnType<typeof getApiKey>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: GetApiKeyPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiKey>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiKey>>, TError, Awaited<ReturnType<typeof getApiKey>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiKey<
    TData = Awaited<ReturnType<typeof getApiKey>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    pathParams: GetApiKeyPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiKey>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get API key detail
 */

export function useGetApiKey<
    TData = Awaited<ReturnType<typeof getApiKey>>,
    TError = ErrorType<
        | UnauthorizedErrorResponseResponse
        | ForbiddenErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
>(
    { apiKeyId }: GetApiKeyPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiKey>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetApiKeyQueryOptions({ apiKeyId }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Update API key
 */
export const updateApiKey = (
    { apiKeyId }: UpdateApiKeyPathParameters,
    updateApiKeyRequestBodyBody: BodyType<UpdateApiKeyRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<UpdateApiKeyResponseResponse>(
        { url: `/api-keys/${apiKeyId}`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: updateApiKeyRequestBodyBody },
        options,
    );
};

export const getUpdateApiKeyMutationOptions = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateApiKey>>,
        TError,
        { pathParams: UpdateApiKeyPathParameters; data: BodyType<UpdateApiKeyRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateApiKey>>,
    TError,
    { pathParams: UpdateApiKeyPathParameters; data: BodyType<UpdateApiKeyRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['updateApiKey'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateApiKey>>,
        { pathParams: UpdateApiKeyPathParameters; data: BodyType<UpdateApiKeyRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return updateApiKey(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof updateApiKey>>>;
export type UpdateApiKeyMutationBody = BodyType<UpdateApiKeyRequestBodyBody>;
export type UpdateApiKeyMutationError = ErrorType<
    | BadRequestErrorResponseResponse
    | UnauthorizedErrorResponseResponse
    | NotFoundErrorResponseResponse
    | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update API key
 */
export const useUpdateApiKey = <
    TError = ErrorType<
        | BadRequestErrorResponseResponse
        | UnauthorizedErrorResponseResponse
        | NotFoundErrorResponseResponse
        | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof updateApiKey>>,
            TError,
            { pathParams: UpdateApiKeyPathParameters; data: BodyType<UpdateApiKeyRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof updateApiKey>>,
    TError,
    { pathParams: UpdateApiKeyPathParameters; data: BodyType<UpdateApiKeyRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getUpdateApiKeyMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Revoke and delete an API key
 */
export const deleteApiKey = ({ apiKeyId }: DeleteApiKeyPathParameters, options?: SecondParameter<typeof fetcher>) => {
    return fetcher<void>({ url: `/api-keys/${apiKeyId}`, method: 'DELETE' }, options);
};

export const getDeleteApiKeyMutationOptions = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | NotFoundErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteApiKey>>, TError, { pathParams: DeleteApiKeyPathParameters }, TContext>;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteApiKey>>, TError, { pathParams: DeleteApiKeyPathParameters }, TContext> => {
    const mutationKey = ['deleteApiKey'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiKey>>, { pathParams: DeleteApiKeyPathParameters }> = props => {
        const { pathParams } = props ?? {};

        return deleteApiKey(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiKey>>>;

export type DeleteApiKeyMutationError = ErrorType<
    UnauthorizedErrorResponseResponse | NotFoundErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Revoke and delete an API key
 */
export const useDeleteApiKey = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | NotFoundErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteApiKey>>,
            TError,
            { pathParams: DeleteApiKeyPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof deleteApiKey>>, TError, { pathParams: DeleteApiKeyPathParameters }, TContext> => {
    const mutationOptions = getDeleteApiKeyMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a record owned by the API key's user. name is required and type defaults to password. The Starter plan allows 15 records per organization and TOTP on 2 records. Passkey fields are rejected on the Starter plan. A blocked request returns 402 with errorData limit and current.

 * @summary Create secret
 */
export const publicCreateSecret = (
    createSecretRequestBodyBody: BodyType<CreateSecretRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
    signal?: AbortSignal,
) => {
    return fetcher<CreateSecretResponseResponse>(
        {
            url: `/public/secrets`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: createSecretRequestBodyBody,
            signal,
        },
        options,
    );
};

export const getPublicCreateSecretMutationOptions = <
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | HttpError | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof publicCreateSecret>>,
        TError,
        { data: BodyType<CreateSecretRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof publicCreateSecret>>,
    TError,
    { data: BodyType<CreateSecretRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['publicCreateSecret'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof publicCreateSecret>>,
        { data: BodyType<CreateSecretRequestBodyBody> }
    > = props => {
        const { data } = props ?? {};

        return publicCreateSecret(data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PublicCreateSecretMutationResult = NonNullable<Awaited<ReturnType<typeof publicCreateSecret>>>;
export type PublicCreateSecretMutationBody = BodyType<CreateSecretRequestBodyBody>;
export type PublicCreateSecretMutationError = ErrorType<
    UnauthorizedErrorResponseResponse | HttpError | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Create secret
 */
export const usePublicCreateSecret = <
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | HttpError | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof publicCreateSecret>>,
            TError,
            { data: BodyType<CreateSecretRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof publicCreateSecret>>, TError, { data: BodyType<CreateSecretRequestBodyBody> }, TContext> => {
    const mutationOptions = getPublicCreateSecretMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * Returns only password-type secrets. The password value is never included; the hasPassword flag indicates whether the secret has one. The X-Total-Count response header carries the total number of secrets. The Starter plan omits the security-audit fields.

 * @summary List secrets
 */
export const publicListSecrets = (params?: PublicListSecretsParams, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<ListSecretResponseResponse>({ url: `/public/secrets`, method: 'GET', params, signal }, options);
};

export const getPublicListSecretsQueryKey = (params?: PublicListSecretsParams) => {
    return [`/public/secrets`, ...(params ? [params] : [])] as const;
};

export const getPublicListSecretsQueryOptions = <
    TData = Awaited<ReturnType<typeof publicListSecrets>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: PublicListSecretsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicListSecrets>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getPublicListSecretsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicListSecrets>>> = ({ signal }) =>
        publicListSecrets(params, requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof publicListSecrets>>, TError, TData> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };
};

export type PublicListSecretsQueryResult = NonNullable<Awaited<ReturnType<typeof publicListSecrets>>>;
export type PublicListSecretsQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function usePublicListSecrets<
    TData = Awaited<ReturnType<typeof publicListSecrets>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params: undefined | PublicListSecretsParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicListSecrets>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof publicListSecrets>>,
                    TError,
                    Awaited<ReturnType<typeof publicListSecrets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePublicListSecrets<
    TData = Awaited<ReturnType<typeof publicListSecrets>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: PublicListSecretsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicListSecrets>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof publicListSecrets>>,
                    TError,
                    Awaited<ReturnType<typeof publicListSecrets>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePublicListSecrets<
    TData = Awaited<ReturnType<typeof publicListSecrets>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: PublicListSecretsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicListSecrets>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List secrets
 */

export function usePublicListSecrets<
    TData = Awaited<ReturnType<typeof publicListSecrets>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    params?: PublicListSecretsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicListSecrets>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPublicListSecretsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Returns the full record of any type, including fields the list endpoint omits. Sensitive fields (listed in the record's sensitiveFields array) are included only when the key's user has the permission to read them. URL-encode the id — it may contain characters like + and =. The Starter plan omits the security-audit fields.

 * @summary Get secret detail
 */
export const publicGetSecret = ({ id }: PublicGetSecretPathParameters, options?: SecondParameter<typeof fetcher>, signal?: AbortSignal) => {
    return fetcher<DetailSecretResponseResponse>({ url: `/public/secrets/${id}`, method: 'GET', signal }, options);
};

export const getPublicGetSecretQueryKey = ({ id }: PublicGetSecretPathParameters) => {
    return [`/public/secrets/${id}`] as const;
};

export const getPublicGetSecretQueryOptions = <
    TData = Awaited<ReturnType<typeof publicGetSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    { id }: PublicGetSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicGetSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getPublicGetSecretQueryKey({ id });

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicGetSecret>>> = ({ signal }) =>
        publicGetSecret({ id }, requestOptions, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof publicGetSecret>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PublicGetSecretQueryResult = NonNullable<Awaited<ReturnType<typeof publicGetSecret>>>;
export type PublicGetSecretQueryError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

export function usePublicGetSecret<
    TData = Awaited<ReturnType<typeof publicGetSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: PublicGetSecretPathParameters,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicGetSecret>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<Awaited<ReturnType<typeof publicGetSecret>>, TError, Awaited<ReturnType<typeof publicGetSecret>>>,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePublicGetSecret<
    TData = Awaited<ReturnType<typeof publicGetSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: PublicGetSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicGetSecret>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof publicGetSecret>>,
                    TError,
                    Awaited<ReturnType<typeof publicGetSecret>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePublicGetSecret<
    TData = Awaited<ReturnType<typeof publicGetSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    pathParams: PublicGetSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicGetSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get secret detail
 */

export function usePublicGetSecret<
    TData = Awaited<ReturnType<typeof publicGetSecret>>,
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
>(
    { id }: PublicGetSecretPathParameters,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof publicGetSecret>>, TError, TData>>;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPublicGetSecretQueryOptions({ id }, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Merge update — fields omitted from the body keep their current values. name is required and the record's type cannot be changed. The Starter plan allows TOTP on 2 records, so TOTP added to a record without TOTP can return 402.

 * @summary Update secret
 */
export const publicUpdateSecret = (
    { id }: PublicUpdateSecretPathParameters,
    updateSecretRequestBodyBody: BodyType<UpdateSecretRequestBodyBody>,
    options?: SecondParameter<typeof fetcher>,
) => {
    return fetcher<UpdateSecretResponseResponse>(
        { url: `/public/secrets/${id}`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: updateSecretRequestBodyBody },
        options,
    );
};

export const getPublicUpdateSecretMutationOptions = <
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | HttpError | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof publicUpdateSecret>>,
        TError,
        { pathParams: PublicUpdateSecretPathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof publicUpdateSecret>>,
    TError,
    { pathParams: PublicUpdateSecretPathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
    TContext
> => {
    const mutationKey = ['publicUpdateSecret'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof publicUpdateSecret>>,
        { pathParams: PublicUpdateSecretPathParameters; data: BodyType<UpdateSecretRequestBodyBody> }
    > = props => {
        const { pathParams, data } = props ?? {};

        return publicUpdateSecret(pathParams, data, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PublicUpdateSecretMutationResult = NonNullable<Awaited<ReturnType<typeof publicUpdateSecret>>>;
export type PublicUpdateSecretMutationBody = BodyType<UpdateSecretRequestBodyBody>;
export type PublicUpdateSecretMutationError = ErrorType<
    UnauthorizedErrorResponseResponse | HttpError | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Update secret
 */
export const usePublicUpdateSecret = <
    TError = ErrorType<
        UnauthorizedErrorResponseResponse | HttpError | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof publicUpdateSecret>>,
            TError,
            { pathParams: PublicUpdateSecretPathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof publicUpdateSecret>>,
    TError,
    { pathParams: PublicUpdateSecretPathParameters; data: BodyType<UpdateSecretRequestBodyBody> },
    TContext
> => {
    const mutationOptions = getPublicUpdateSecretMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete secret
 */
export const publicDeleteSecret = ({ id }: PublicDeleteSecretPathParameters, options?: SecondParameter<typeof fetcher>) => {
    return fetcher<void>({ url: `/public/secrets/${id}`, method: 'DELETE' }, options);
};

export const getPublicDeleteSecretMutationOptions = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof publicDeleteSecret>>,
        TError,
        { pathParams: PublicDeleteSecretPathParameters },
        TContext
    >;
    request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
    Awaited<ReturnType<typeof publicDeleteSecret>>,
    TError,
    { pathParams: PublicDeleteSecretPathParameters },
    TContext
> => {
    const mutationKey = ['publicDeleteSecret'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof publicDeleteSecret>>,
        { pathParams: PublicDeleteSecretPathParameters }
    > = props => {
        const { pathParams } = props ?? {};

        return publicDeleteSecret(pathParams, requestOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PublicDeleteSecretMutationResult = NonNullable<Awaited<ReturnType<typeof publicDeleteSecret>>>;

export type PublicDeleteSecretMutationError = ErrorType<
    UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse
>;

/**
 * @summary Delete secret
 */
export const usePublicDeleteSecret = <
    TError = ErrorType<UnauthorizedErrorResponseResponse | ForbiddenErrorResponseResponse | PreconditionRequiredErrorResponseResponse>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof publicDeleteSecret>>,
            TError,
            { pathParams: PublicDeleteSecretPathParameters },
            TContext
        >;
        request?: SecondParameter<typeof fetcher>;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof publicDeleteSecret>>,
    TError,
    { pathParams: PublicDeleteSecretPathParameters },
    TContext
> => {
    const mutationOptions = getPublicDeleteSecretMutationOptions(options);

    return useMutation(mutationOptions, queryClient);
};
